webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(10);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(12);
	
	__webpack_require__(14);
	
	var _app = __webpack_require__(15);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(27);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(38);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _navbar = __webpack_require__(42);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(44);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(46);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _feedback = __webpack_require__(49);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _articles = __webpack_require__(52);
	
	var _articles2 = _interopRequireDefault(_articles);
	
	var _article = __webpack_require__(55);
	
	var _article2 = _interopRequireDefault(_article);
	
	var _articleVideo = __webpack_require__(58);
	
	var _articleVideo2 = _interopRequireDefault(_articleVideo);
	
	var _recipes = __webpack_require__(61);
	
	var _recipes2 = _interopRequireDefault(_recipes);
	
	var _recipe = __webpack_require__(64);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _initiatives = __webpack_require__(67);
	
	var _initiatives2 = _interopRequireDefault(_initiatives);
	
	var _initiative = __webpack_require__(70);
	
	var _initiative2 = _interopRequireDefault(_initiative);
	
	var _initiativeVideo = __webpack_require__(73);
	
	var _initiativeVideo2 = _interopRequireDefault(_initiativeVideo);
	
	var _app2 = __webpack_require__(17);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(19);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _searchService = __webpack_require__(76);
	
	var _searchService2 = _interopRequireDefault(_searchService);
	
	__webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('connectwellApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, 'angucomplete-alt', _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _footer2.default, _main2.default, _feedback2.default, _articles2.default, _article2.default, _articleVideo2.default, _recipes2.default, _recipe2.default, _initiatives2.default, _initiative2.default, _initiativeVideo2.default, _app3.default, _util2.default, _searchService2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {
	    'ngInject';
	
	    $rootScope.$on('$stateChangeStart', function (event, next) {
	        Auth.isLoggedIn(function (loggedIn) {
	            if (next.authenticate && !loggedIn) {
	                $location.path('/login');
	            }
	        });
	    });
	
	    $rootScope.$watch('canonical', function (newVal) {
	        if (newVal != '') {
	            var link = _angular2.default.element('<link>');
	            link.attr('rel', 'canonical');
	            link.attr('href', newVal);
	
	            _angular2.default.element('head').append(link);
	        }
	    });
	}]);
	
	_angular2.default.element(document).ready(function () {
	    _angular2.default.bootstrap(document, ['connectwellApp'], {
	        strictDi: true
	    });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	
	module.exports = 'ui.bootstrap';


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 2.5.6 - 2017-10-14
	 * License: MIT
	 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	        init();
	
	        function init() {
	          horizontal = !!('horizontal' in attrs);
	          if (horizontal) {
	            css = {
	              width: ''
	            };
	            cssTo = {width: '0'};
	          } else {
	            css = {
	              height: ''
	            };
	            cssTo = {height: '0'};
	          }
	          if (!scope.$eval(attrs.uibCollapse)) {
	            element.addClass('in')
	              .addClass('collapse')
	              .attr('aria-expanded', true)
	              .attr('aria-hidden', false)
	              .css(css);
	          }
	        }
	
	        function getScrollFromElement(element) {
	          if (horizontal) {
	            return {width: element.scrollWidth + 'px'};
	          }
	          return {height: element.scrollHeight + 'px'};
	        }
	
	        function expand() {
	          if (element.hasClass('collapse') && element.hasClass('in')) {
	            return;
	          }
	
	          $q.resolve(expandingExpr(scope))
	            .then(function() {
	              element.removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', true)
	                .attr('aria-hidden', false);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  addClass: 'in',
	                  easing: 'ease',
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).start()['finally'](expandDone);
	              } else {
	                $animate.addClass(element, 'in', {
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).then(expandDone);
	              }
	            }, angular.noop);
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css(css);
	          expandedExpr(scope);
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          $q.resolve(collapsingExpr(scope))
	            .then(function() {
	              element
	              // IMPORTANT: The width must be set before adding "collapsing" class.
	              // Otherwise, the browser attempts to animate from width 0 (in
	              // collapsing class) to the given width here.
	                .css(getScrollFromElement(element[0]))
	                // initially all panel collapse have the collapse class, this removal
	                // prevents the animation from jumping to collapsed state
	                .removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', false)
	                .attr('aria-hidden', true);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: 'in',
	                  to: cssTo
	                }).start()['finally'](collapseDone);
	              } else {
	                $animate.removeClass(element, 'in', {
	                  to: cssTo
	                }).then(collapseDone);
	              }
	            }, angular.noop);
	        }
	
	        function collapseDone() {
	          element.css(cssTo); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	          collapsedExpr(scope);
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      panelClass: '@?',           // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, controller) {
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	      return 'uib-accordion-header,' +
	          'data-uib-accordion-header,' +
	          'x-uib-accordion-header,' +
	          'uib\\:accordion-header,' +
	          '[uib-accordion-header],' +
	          '[data-uib-accordion-header],' +
	          '[x-uib-accordion-header]';
	  }
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', ['$parse', function($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function(uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}])
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = $scope.active,
	    currentInterval, isPlaying;
	
	  var destroyed = false;
	  $element.addClass('carousel');
	
	  self.addSlide = function(slide, element) {
	    slides.push({
	      slide: slide,
	      element: element
	    });
	    slides.sort(function(a, b) {
	      return +a.slide.index - +b.slide.index;
	    });
	    //if this is the first slide or the slide is set to active, select it
	    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition = null;
	      }
	
	      currentIndex = slide.index;
	      $scope.active = slide.index;
	      setActive(currentIndex);
	      self.select(slides[findSlideIndex(slide)]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    }
	  };
	
	  self.getCurrentIndex = function() {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide.index === currentIndex) {
	        return i;
	      }
	    }
	  };
	
	  self.next = $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'next');
	  };
	
	  self.prev = $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'prev');
	  };
	
	  self.removeSlide = function(slide) {
	    var index = findSlideIndex(slide);
	
	    //get the index of the slide inside the carousel
	    slides.splice(index, 1);
	    if (slides.length > 0 && currentIndex === index) {
	      if (index >= slides.length) {
	        currentIndex = slides.length - 1;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[slides.length - 1]);
	      } else {
	        currentIndex = index;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	      $scope.active = currentIndex;
	    }
	
	    //clean the active value when no more slide
	    if (slides.length === 0) {
	      currentIndex = null;
	      $scope.active = null;
	    }
	  };
	
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = findSlideIndex(nextSlide.slide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide.slide.index !== currentIndex &&
	      !$scope.$currentTransition) {
	      goNext(nextSlide.slide, nextIndex, direction);
	    }
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return +slide.slide.index;
	  };
	
	  $scope.isActive = function(slide) {
	    return $scope.active === slide.slide.index;
	  };
	
	  $scope.isPrevDisabled = function() {
	    return $scope.active === 0 && $scope.noWrap();
	  };
	
	  $scope.isNextDisabled = function() {
	    return $scope.active === slides.length - 1 && $scope.noWrap();
	  };
	
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	
	  $element.on('mouseenter', $scope.pause);
	  $element.on('mouseleave', $scope.play);
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	    resetTimer();
	  });
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $animate.enabled($element, !noTransition);
	  });
	
	  $scope.$watch('interval', restartTimer);
	
	  $scope.$watchCollection('slides', resetTransition);
	
	  $scope.$watch('active', function(index) {
	    if (angular.isNumber(index) && currentIndex !== index) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === index) {
	          index = i;
	          break;
	        }
	      }
	
	      var slide = slides[index];
	      if (slide) {
	        setActive(index);
	        self.select(slides[index]);
	        currentIndex = index;
	      }
	    }
	  });
	
	  function getSlideByIndex(index) {
	    for (var i = 0, l = slides.length; i < l; ++i) {
	      if (slides[i].index === index) {
	        return slides[i];
	      }
	    }
	  }
	
	  function setActive(index) {
	    for (var i = 0; i < slides.length; i++) {
	      slides[i].slide.active = i === index;
	    }
	  }
	
	  function goNext(slide, index, direction) {
	    if (destroyed) {
	      return;
	    }
	
	    angular.extend(slide, {direction: direction});
	    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
	    if ($animate.enabled($element) && !$scope.$currentTransition &&
	      slides[index].element && self.slides.length > 1) {
	      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	      var currentIdx = self.getCurrentIndex();
	
	      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      $animate.on('addClass', slides[index].element, function(element, phase) {
	        if (phase === 'close') {
	          $scope.$currentTransition = null;
	          $animate.off('addClass', element);
	        }
	      });
	    }
	
	    $scope.active = slide.index;
	    currentIndex = slide.index;
	    setActive(index);
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  function findSlideIndex(slide) {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide === slide) {
	        return i;
	      }
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	}])
	
	.directive('uibCarousel', function() {
	  return {
	    transclude: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	    },
	    scope: {
	      active: '=',
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	})
	
	.directive('uibSlide', ['$animate', function($animate) {
	  return {
	    require: '^uibCarousel',
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/slide.html';
	    },
	    scope: {
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      element.addClass('item');
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
	      });
	    }
	  };
	}])
	
	.animation('.item', ['$animateCss',
	function($animateCss) {
	  var SLIDE_DIRECTION = 'uib-slideDirection';
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [
	      {
	        key: 'yyyy',
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yyyy');
	        }
	      },
	      {
	        key: 'yy',
	        regex: '\\d{2}',
	        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yy');
	        }
	      },
	      {
	        key: 'y',
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'y');
	        }
	      },
	      {
	        key: 'M!',
	        regex: '0?[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) {
	          var value = date.getMonth();
	          if (/^[0-9]$/.test(value)) {
	            return dateFilter(date, 'MM');
	          }
	
	          return dateFilter(date, 'M');
	        }
	      },
	      {
	        key: 'MMMM',
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMMM'); }
	      },
	      {
	        key: 'MMM',
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMM'); }
	      },
	      {
	        key: 'MM',
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'MM'); }
	      },
	      {
	        key: 'M',
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'M'); }
	      },
	      {
	        key: 'd!',
	        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) {
	          var value = date.getDate();
	          if (/^[1-9]$/.test(value)) {
	            return dateFilter(date, 'dd');
	          }
	
	          return dateFilter(date, 'd');
	        }
	      },
	      {
	        key: 'dd',
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'dd'); }
	      },
	      {
	        key: 'd',
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'd'); }
	      },
	      {
	        key: 'EEEE',
	        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEEE'); }
	      },
	      {
	        key: 'EEE',
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEE'); }
	      },
	      {
	        key: 'HH',
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'HH'); }
	      },
	      {
	        key: 'hh',
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'hh'); }
	      },
	      {
	        key: 'H',
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'H'); }
	      },
	      {
	        key: 'h',
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'h'); }
	      },
	      {
	        key: 'mm',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'mm'); }
	      },
	      {
	        key: 'm',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'm'); }
	      },
	      {
	        key: 'sss',
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'sss'); }
	      },
	      {
	        key: 'ss',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'ss'); }
	      },
	      {
	        key: 's',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 's'); }
	      },
	      {
	        key: 'a',
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        },
	        formatter: function(date) { return dateFilter(date, 'a'); }
	      },
	      {
	        key: 'Z',
	        regex: '[+-]\\d{4}',
	        apply: function(value) {
	          var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	          this.hours += toInt(sign + hours);
	          this.minutes += toInt(sign + minutes);
	        },
	        formatter: function(date) {
	          return dateFilter(date, 'Z');
	        }
	      },
	      {
	        key: 'ww',
	        regex: '[0-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'ww'); }
	      },
	      {
	        key: 'w',
	        regex: '[0-9]|[1-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'w'); }
	      },
	      {
	        key: 'GGGG',
	        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	        formatter: function(date) { return dateFilter(date, 'GGGG'); }
	      },
	      {
	        key: 'GGG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GGG'); }
	      },
	      {
	        key: 'GG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GG'); }
	      },
	      {
	        key: 'G',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'G'); }
	      }
	    ];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'LLLL'); }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
	              format[i+1] = '$';
	              regex[i+1] = '';
	            } else { // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') { // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function(data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function() {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function(date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function(str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
	        Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours :
	        Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes,
	            fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
	            fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', [])
	.directive('uibIsClass', [
	         '$animate',
	function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function(exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function(compareWithVal) {
	            var newActivated = null;
	            instances.some(function(instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function(data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])
	
	.value('$datepickerSuppressError', false)
	
	.value('$datepickerLiteralWarning', true)
	
	.constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	})
	
	.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
	  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
	      ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  [
	    'customClass',
	    'dateDisabled',
	    'datepickerMode',
	    'formatDay',
	    'formatDayHeader',
	    'formatDayTitle',
	    'formatMonth',
	    'formatMonthTitle',
	    'formatYear',
	    'maxDate',
	    'maxMode',
	    'minDate',
	    'minMode',
	    'monthColumns',
	    'showWeeks',
	    'shortcutPropagation',
	    'startingDay',
	    'yearColumns',
	    'yearRows'
	  ].forEach(function(key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
	          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
	          datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function(value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ?
	              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
	              null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
	              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function(initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ?
	      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
	      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date ||
	        this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function(date) {
	    return $scope.disabled ||
	      this.minDate && this.compare(date, this.minDate) < 0 ||
	      this.maxDate && this.compare(date, this.maxDate) > 0 ||
	      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
	      $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function(evt) {
	    $scope.$apply(function() {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function() {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options ||
	        $scope.datepickerOptions.ngModelOptions ||
	        datepickerConfig.ngModelOptions ||
	        {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') ||
	        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
	        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	        .createChild($scope.datepickerOptions.ngModelOptions)
	        .createChild(ngModelCtrl.$options) // highest precedence
	        .createChild({timezone: timezone}); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 &&
	      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = difference > 0 ?
	        7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])
	
	.value('$datepickerPopupLiteralWarning', true)
	
	.constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
	function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
	    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
	      $scope.$parent.$eval($attrs.closeOnDateSelection) :
	      datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
	      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
	      datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
	      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
	      $attrs.datepickerPopupTemplateUrl :
	      datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
	      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
	      $scope.$parent.$eval($attrs.altInputFormats) :
	      datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
	      $scope.$parent.$eval($attrs.showButtonBar) :
	      datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function() {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function() {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function(key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions &&
	      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
	      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function(dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function(date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function(evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function(value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function() {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
	        ngModelCtrl.$options :
	        {
	          timezone: null
	        };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function() {
	    $timeout(positionPopup, 0, false);
	  });
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.debounce', [])
	/**
	 * A helper, internal service that debounces a function
	 */
	  .factory('$$debounce', ['$timeout', function($timeout) {
	    return function(callback, debounceTime) {
	      var timeoutPromise;
	
	      return function() {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function() {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function(dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function(dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function(dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function(dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled') { return; }
	
	    if (evt && evt.which === 3) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function(evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function(open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1;
	        }
	        break;
	      }
	      case 38: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    var appendTo = null,
	      appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign,
	        scrollbarPadding,
	        scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth -
	          (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth -
	            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	
	.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
	  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
	
	  uibPaging.create(this, $scope, $attrs);
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPagerController',
	    controllerAs: 'pager',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pager/pager.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pager');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function(maxParam) {
	    self.bars.forEach(function(bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault () {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  enableReset: true,
	  titles: ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl = { $setViewValue: angular.noop },
	    self = this;
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    this.enableReset = angular.isDefined($attrs.enableReset) ?
	      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
	    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    }
	
	    return this.titles[index];
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
	      ngModelCtrl.$setViewValue(newViewValue);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.title = self.getTitle($scope.value - 1);
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    restrict: 'A',
	    scope: {
	      readonly: '=?readOnly',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'uib/template/rating/rating.html',
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	    oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function(index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function(t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
	        index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function(val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}])
	
	.directive('uibTabset', function() {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ?
	        scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ?
	        scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function(evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'uib:tab-heading'
	    );
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	    watchers = [],
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function() {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function() {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
	      hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
	      '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	     secondsInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function() {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function(e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply( function() {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	        minutes = selected.getMinutes(),
	        seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes*60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') &&
	      ($scope.minutes === null || $scope.minutes === '') &&
	      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function() {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function() {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function() {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function() {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}])
	
	.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	        minLength = !newVal && newVal !== 0 ? 1 : newVal;
	    });
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	      isEditable = newVal !== false;
	    });
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a function to determine if an event should cause selection
	    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
	      var evt = vals.$event;
	      return evt.which === 13 || evt.which === 9;
	    };
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendTo = attrs.typeaheadAppendTo ?
	      originalScope.$eval(attrs.typeaheadAppendTo) : null;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //binding to a variable that indicates if dropdown is open
	    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
	
	    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions.getOption('getterSetter')) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      }
	
	      return parsedModel.assign(scope, newValue);
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    var inputsContainer, hintInputElem;
	    //add read-only input to show hint
	    if (showHint) {
	      inputsContainer = angular.element('<div></div>');
	      inputsContainer.css('position', 'relative');
	      element.after(inputsContainer);
	      hintInputElem = element.clone();
	      hintInputElem.attr('placeholder', '');
	      hintInputElem.attr('tabindex', '-1');
	      hintInputElem.val('');
	      hintInputElem.css({
	        'position': 'absolute',
	        'top': '0px',
	        'left': '0px',
	        'border-color': 'transparent',
	        'box-shadow': 'none',
	        'opacity': 1,
	        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	        'color': '#999'
	      });
	      element.css({
	        'position': 'relative',
	        'vertical-align': 'top',
	        'background-color': 'transparent'
	      });
	
	      if (hintInputElem.attr('id')) {
	        hintInputElem.removeAttr('id'); // remove duplicate id if present.
	      }
	      inputsContainer.append(hintInputElem);
	      hintInputElem.after(element);
	    }
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx, evt)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position',
	      'assign-is-open': 'assignIsOpen(isOpen)',
	      debounce: 'debounceUpdate'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetHint = function() {
	      if (showHint) {
	        hintInputElem.val('');
	      }
	    };
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	      resetHint();
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue, evt) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(0, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(0, evt);
	              }
	            }
	
	            if (showHint) {
	              var firstLabel = scope.matches[0].label;
	              if (angular.isString(inputValue) &&
	                inputValue.length > 0 &&
	                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	              } else {
	                hintInputElem.val('');
	              }
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).on('resize', fireRecalculating);
	      $document.find('body').on('scroll', fireRecalculating);
	    }
	
	    // Declare the debounced function outside recalculating for
	    // proper debouncing
	    var debouncedRecalculate = $$debounce(function() {
	      // if popup is visible
	      if (scope.matches.length) {
	        recalculatePosition();
	      }
	
	      scope.moveInProgress = false;
	    }, eventDebounceTime);
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      debouncedRecalculate();
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.assignIsOpen = function (isOpen) {
	      isOpenSetter(originalScope, isOpen);
	    };
	
	    scope.select = function(activeIdx, evt) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals),
	        $event: evt
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.on('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      var shouldSelect = isSelectEvent(originalScope, {$event: evt});
	
	      /**
	       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	       * or
	       * shift + tab is pressed to bring focus to the previous element
	       * then clear the results
	       */
	      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	      var target;
	      switch (evt.which) {
	        case 27: // escape
	          evt.stopPropagation();
	
	          resetMatches();
	          originalScope.$digest();
	          break;
	        case 38: // up arrow
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        case 40: // down arrow
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        default:
	          if (shouldSelect) {
	            scope.$apply(function() {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(scope.activeIdx, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(scope.activeIdx, evt);
	              }
	            });
	          }
	      }
	    });
	
	    element.on('focus', function (evt) {
	      hasFocus = true;
	      if (minLength === 0 && !modelCtrl.$viewValue) {
	        $timeout(function() {
	          getMatchesAsync(modelCtrl.$viewValue, evt);
	        }, 0);
	      }
	    });
	
	    element.on('blur', function(evt) {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	            $$debounce(function() {
	              scope.select(scope.activeIdx, evt);
	            }, scope.debounceUpdate.blur);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	      }
	      if (!isEditable && modelCtrl.$error.editable) {
	        modelCtrl.$setViewValue();
	        scope.$apply(function() {
	          // Reset validity as we are clearing
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	        });
	        element.val('');
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          originalScope.$digest();
	        }
	      }
	    };
	
	    $document.on('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.off('click', dismissClickHandler);
	      if (appendToBody || appendTo) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).off('resize', fireRecalculating);
	        $document.find('body').off('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	
	      if (showHint) {
	          inputsContainer.remove();
	      }
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendTo) {
	      angular.element(appendTo).eq(0).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = extractOptions(modelCtrl);
	
	      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        }
	
	        if (!inputValue) {
	          // Reset in case user had typed something previously.
	          modelCtrl.$setValidity('editable', true);
	          return null;
	        }
	
	        modelCtrl.$setValidity('editable', false);
	        return undefined;
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        }
	
	        //it might happen that we don't have enough info to properly render input value
	        //we need to check for this situation and simply return model value if we can't apply custom formatting
	        locals[parserResult.itemName] = modelValue;
	        candidateViewValue = parserResult.viewMapper(originalScope, locals);
	        locals[parserResult.itemName] = undefined;
	        emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	      });
	    };
	
	    function extractOptions(ngModelCtrl) {
	      var ngModelOptions;
	
	      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	        // guarantee a value
	        ngModelOptions = ngModelCtrl.$options || {};
	
	        // mimic 1.6+ api
	        ngModelOptions.getOption = function (key) {
	          return ngModelOptions[key];
	        };
	      } else { // in angular >=1.6 $options is always present
	        ngModelOptions = ngModelCtrl.$options;
	      }
	
	      return ngModelOptions;
	    }
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[1].init(ctrls[0]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&',
	        assignIsOpen: '&',
	        debounce: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          var isDropdownOpen = scope.matches.length > 0;
	          scope.assignIsOpen({ isOpen: isDropdownOpen });
	          return isDropdownOpen;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active === matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx, evt) {
	          var debounce = scope.debounce();
	          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	            $$debounce(function() {
	              scope.select({activeIdx: activeIdx, evt: evt});
	            }, angular.isNumber(debounce) ? debounce : debounce['default']);
	          } else {
	            scope.select({activeIdx: activeIdx, evt: evt});
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link: function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          var tplEl = angular.element(tplContent.trim());
	          element.replaceWith(tplEl);
	          $compile(tplEl)(scope);
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html",
	    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "  <h4 class=\"panel-title\">\n" +
	    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "  </h4>\n" +
	    "</div>\n" +
	    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html",
	    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html",
	    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "  <span aria-hidden=\"true\">&times;</span>\n" +
	    "  <span class=\"sr-only\">Close</span>\n" +
	    "</button>\n" +
	    "<div ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/carousel.html",
	    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "  <span class=\"sr-only\">previous</span>\n" +
	    "</a>\n" +
	    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "  <span class=\"sr-only\">next</span>\n" +
	    "</a>\n" +
	    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "  </li>\n" +
	    "</ol>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/slide.html",
	    "<div class=\"text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\">\n" +
	    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
	    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
	    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/datepicker/popup.html",
	    "<div>\n" +
	    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "    <li ng-transclude></li>\n" +
	    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "      <span class=\"btn-group pull-left\">\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "      </span>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "    </li>\n" +
	    "  </ul>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html",
	    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "  <li ng-transclude></li>\n" +
	    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "    <span class=\"btn-group pull-left\">\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "    </span>\n" +
	    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "  </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pager/pager.html",
	    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\"\n" +
	    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html",
	    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
	    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\"\n" +
	    "         ng-repeat=\"tab in tabset.tabs\"\n" +
	    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html",
	    "<table class=\"uib-timepicker\">\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
	    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-match.html",
	    "<a href\n" +
	    "   tabindex=\"-1\"\n" +
	    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
	    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
	angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
	angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
	angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
	angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
	angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
	angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	module.exports = 'validation.match';


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * angucomplete-alt
	 * Autocomplete directive for AngularJS
	 * This is a fork of Daryl Rowland's angucomplete with some extra features.
	 * By Hidenari Nozaki
	 */
	
	/*! Copyright (c) 2014 Hidenari Nozaki and contributors | Licensed under the MIT license */
	
	(function (root, factory) {
	  'use strict';
	  if (typeof module !== 'undefined' && module.exports) {
	    // CommonJS
	    module.exports = factory(__webpack_require__(1));
	  } else if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Global Variables
	    factory(root.angular);
	  }
	}(window, function (angular) {
	  'use strict';
	
	  angular.module('angucomplete-alt', []).directive('angucompleteAlt', ['$q', '$parse', '$http', '$sce', '$timeout', '$templateCache', '$interpolate', function ($q, $parse, $http, $sce, $timeout, $templateCache, $interpolate) {
	    // keyboard events
	    var KEY_DW  = 40;
	    var KEY_RT  = 39;
	    var KEY_UP  = 38;
	    var KEY_LF  = 37;
	    var KEY_ES  = 27;
	    var KEY_EN  = 13;
	    var KEY_TAB =  9;
	
	    var MIN_LENGTH = 3;
	    var MAX_LENGTH = 524288;  // the default max length per the html maxlength attribute
	    var PAUSE = 500;
	    var BLUR_TIMEOUT = 200;
	
	    // string constants
	    var REQUIRED_CLASS = 'autocomplete-required';
	    var TEXT_SEARCHING = 'Searching...';
	    var TEXT_NORESULTS = 'No results found';
	    var TEMPLATE_URL = '/angucomplete-alt/index.html';
	
	    // Set the default template for this directive
	    $templateCache.put(TEMPLATE_URL,
	        '<div class="angucomplete-holder" ng-class="{\'angucomplete-dropdown-visible\': showDropdown}">' +
	        '  <input id="{{id}}_value" name="{{inputName}}" tabindex="{{fieldTabindex}}" ng-class="{\'angucomplete-input-not-empty\': notEmpty}" ng-model="searchStr" ng-disabled="disableInput" type="{{inputType}}" placeholder="{{placeholder}}" maxlength="{{maxlength}}" ng-focus="onFocusHandler()" class="{{inputClass}}" ng-focus="resetHideResults()" ng-blur="hideResults($event)" autocapitalize="off" autocorrect="off" autocomplete="off" ng-change="inputChangeHandler(searchStr)"/>' +
	        '  <div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-show="showDropdown">' +
	        '    <div class="angucomplete-searching" ng-show="searching" ng-bind="textSearching"></div>' +
	        '    <div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)" ng-bind="textNoResults"></div>' +
	        '    <div class="angucomplete-row" ng-repeat="result in results" ng-click="selectResult(result)" ng-mouseenter="hoverRow($index)" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">' +
	        '      <div ng-if="imageField" class="angucomplete-image-holder">' +
	        '        <img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/>' +
	        '        <div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div>' +
	        '      </div>' +
	        '      <div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' +
	        '      <div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>' +
	        '      <div ng-if="matchClass && result.description && result.description != \'\'" class="angucomplete-description" ng-bind-html="result.description"></div>' +
	        '      <div ng-if="!matchClass && result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div>' +
	        '    </div>' +
	        '  </div>' +
	        '</div>'
	    );
	
	    function link(scope, elem, attrs, ctrl) {
	      var inputField = elem.find('input');
	      var minlength = MIN_LENGTH;
	      var searchTimer = null;
	      var hideTimer;
	      var requiredClassName = REQUIRED_CLASS;
	      var responseFormatter;
	      var validState = null;
	      var httpCanceller = null;
	      var httpCallInProgress = false;
	      var dd = elem[0].querySelector('.angucomplete-dropdown');
	      var isScrollOn = false;
	      var mousedownOn = null;
	      var unbindInitialValue;
	      var displaySearching;
	      var displayNoResults;
	
	      elem.on('mousedown', function(event) {
	        if (event.target.id) {
	          mousedownOn = event.target.id;
	          if (mousedownOn === scope.id + '_dropdown') {
	            document.body.addEventListener('click', clickoutHandlerForDropdown);
	          }
	        }
	        else {
	          mousedownOn = event.target.className;
	        }
	      });
	
	      scope.currentIndex = scope.focusFirst ? 0 : null;
	      scope.searching = false;
	      unbindInitialValue = scope.$watch('initialValue', function(newval) {
	        if (newval) {
	          // remove scope listener
	          unbindInitialValue();
	          // change input
	          handleInputChange(newval, true);
	        }
	      });
	
	      scope.$watch('fieldRequired', function(newval, oldval) {
	        if (newval !== oldval) {
	          if (!newval) {
	            ctrl[scope.inputName].$setValidity(requiredClassName, true);
	          }
	          else if (!validState || scope.currentIndex === -1) {
	            handleRequired(false);
	          }
	          else {
	            handleRequired(true);
	          }
	        }
	      });
	
	      scope.$on('angucomplete-alt:clearInput', function (event, elementId) {
	        if (!elementId || elementId === scope.id) {
	          scope.searchStr = null;
	          callOrAssign();
	          handleRequired(false);
	          clearResults();
	        }
	      });
	
	      scope.$on('angucomplete-alt:changeInput', function (event, elementId, newval) {
	        if (!!elementId && elementId === scope.id) {
	          handleInputChange(newval);
	        }
	      });
	
	      function handleInputChange(newval, initial) {
	        if (newval) {
	          if (typeof newval === 'object') {
	            scope.searchStr = extractTitle(newval);
	            callOrAssign({originalObject: newval});
	          } else if (typeof newval === 'string' && newval.length > 0) {
	            scope.searchStr = newval;
	          } else {
	            if (console && console.error) {
	              console.error('Tried to set ' + (!!initial ? 'initial' : '') + ' value of angucomplete to', newval, 'which is an invalid value');
	            }
	          }
	
	          handleRequired(true);
	        }
	      }
	
	      // #194 dropdown list not consistent in collapsing (bug).
	      function clickoutHandlerForDropdown(event) {
	        mousedownOn = null;
	        scope.hideResults(event);
	        document.body.removeEventListener('click', clickoutHandlerForDropdown);
	      }
	
	      // for IE8 quirkiness about event.which
	      function ie8EventNormalizer(event) {
	        return event.which ? event.which : event.keyCode;
	      }
	
	      function callOrAssign(value) {
	        if (typeof scope.selectedObject === 'function') {
	          scope.selectedObject(value, scope.selectedObjectData);
	        }
	        else {
	          scope.selectedObject = value;
	        }
	
	        if (value) {
	          handleRequired(true);
	        }
	        else {
	          handleRequired(false);
	        }
	      }
	
	      function callFunctionOrIdentity(fn) {
	        return function(data) {
	          return scope[fn] ? scope[fn](data) : data;
	        };
	      }
	
	      function setInputString(str) {
	        callOrAssign({originalObject: str});
	
	        if (scope.clearSelected) {
	          scope.searchStr = null;
	        }
	        clearResults();
	      }
	
	      function extractTitle(data) {
	        // split title fields and run extractValue for each and join with ' '
	        return scope.titleField.split(',')
	          .map(function(field) {
	            return extractValue(data, field);
	          })
	          .join(' ');
	      }
	
	      function extractValue(obj, key) {
	        var keys, result;
	        if (key) {
	          keys= key.split('.');
	          result = obj;
	          for (var i = 0; i < keys.length; i++) {
	            result = result[keys[i]];
	          }
	        }
	        else {
	          result = obj;
	        }
	        return result;
	      }
	
	      function findMatchString(target, str) {
	        var result, matches, re;
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	        // Escape user input to be treated as a literal string within a regular expression
	        re = new RegExp(str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
	        if (!target) { return; }
	        if (!target.match || !target.replace) { target = target.toString(); }
	        matches = target.match(re);
	        if (matches) {
	          result = target.replace(re,
	              '<span class="'+ scope.matchClass +'">'+ matches[0] +'</span>');
	        }
	        else {
	          result = target;
	        }
	        return $sce.trustAsHtml(result);
	      }
	
	      function handleRequired(valid) {
	        scope.notEmpty = valid;
	        validState = scope.searchStr;
	        if (scope.fieldRequired && ctrl && scope.inputName) {
	          ctrl[scope.inputName].$setValidity(requiredClassName, valid);
	        }
	      }
	
	      function keyupHandler(event) {
	        var which = ie8EventNormalizer(event);
	        if (which === KEY_LF || which === KEY_RT) {
	          // do nothing
	          return;
	        }
	
	        if (which === KEY_UP || which === KEY_EN) {
	          event.preventDefault();
	        }
	        else if (which === KEY_DW) {
	          event.preventDefault();
	          if (!scope.showDropdown && scope.searchStr && scope.searchStr.length >= minlength) {
	            initResults();
	            scope.searching = true;
	            searchTimerComplete(scope.searchStr);
	          }
	        }
	        else if (which === KEY_ES) {
	          clearResults();
	          scope.$apply(function() {
	            inputField.val(scope.searchStr);
	          });
	        }
	        else {
	          if (minlength === 0 && !scope.searchStr) {
	            return;
	          }
	
	          if (!scope.searchStr || scope.searchStr === '') {
	            scope.showDropdown = false;
	          } else if (scope.searchStr.length >= minlength) {
	            initResults();
	
	            if (searchTimer) {
	              $timeout.cancel(searchTimer);
	            }
	
	            scope.searching = true;
	
	            searchTimer = $timeout(function() {
	              searchTimerComplete(scope.searchStr);
	            }, scope.pause);
	          }
	
	          if (validState && validState !== scope.searchStr && !scope.clearSelected) {
	            scope.$apply(function() {
	              callOrAssign();
	            });
	          }
	        }
	      }
	
	      function handleOverrideSuggestions(event) {
	        if (scope.overrideSuggestions &&
	            !(scope.selectedObject && scope.selectedObject.originalObject === scope.searchStr)) {
	          if (event) {
	            event.preventDefault();
	          }
	
	          // cancel search timer
	          $timeout.cancel(searchTimer);
	          // cancel http request
	          cancelHttpRequest();
	
	          setInputString(scope.searchStr);
	        }
	      }
	
	      function dropdownRowOffsetHeight(row) {
	        var css = getComputedStyle(row);
	        return row.offsetHeight +
	          parseInt(css.marginTop, 10) + parseInt(css.marginBottom, 10);
	      }
	
	      function dropdownHeight() {
	        return dd.getBoundingClientRect().top +
	          parseInt(getComputedStyle(dd).maxHeight, 10);
	      }
	
	      function dropdownRow() {
	        return elem[0].querySelectorAll('.angucomplete-row')[scope.currentIndex];
	      }
	
	      function dropdownRowTop() {
	        return dropdownRow().getBoundingClientRect().top -
	          (dd.getBoundingClientRect().top +
	           parseInt(getComputedStyle(dd).paddingTop, 10));
	      }
	
	      function dropdownScrollTopTo(offset) {
	        dd.scrollTop = dd.scrollTop + offset;
	      }
	
	      function updateInputField(){
	        var current = scope.results[scope.currentIndex];
	        if (scope.matchClass) {
	          inputField.val(extractTitle(current.originalObject));
	        }
	        else {
	          inputField.val(current.title);
	        }
	      }
	
	      function keydownHandler(event) {
	        var which = ie8EventNormalizer(event);
	        var row = null;
	        var rowTop = null;
	
	        if (which === KEY_EN && scope.results) {
	          if (scope.currentIndex >= 0 && scope.currentIndex < scope.results.length) {
	            event.preventDefault();
	            scope.selectResult(scope.results[scope.currentIndex]);
	          } else {
	            handleOverrideSuggestions(event);
	            clearResults();
	          }
	          scope.$apply();
	        } else if (which === KEY_DW && scope.results) {
	          event.preventDefault();
	          if ((scope.currentIndex + 1) < scope.results.length && scope.showDropdown) {
	            scope.$apply(function() {
	              scope.currentIndex ++;
	              updateInputField();
	            });
	
	            if (isScrollOn) {
	              row = dropdownRow();
	              if (dropdownHeight() < row.getBoundingClientRect().bottom) {
	                dropdownScrollTopTo(dropdownRowOffsetHeight(row));
	              }
	            }
	          }
	        } else if (which === KEY_UP && scope.results) {
	          event.preventDefault();
	          if (scope.currentIndex >= 1) {
	            scope.$apply(function() {
	              scope.currentIndex --;
	              updateInputField();
	            });
	
	            if (isScrollOn) {
	              rowTop = dropdownRowTop();
	              if (rowTop < 0) {
	                dropdownScrollTopTo(rowTop - 1);
	              }
	            }
	          }
	          else if (scope.currentIndex === 0) {
	            scope.$apply(function() {
	              scope.currentIndex = -1;
	              inputField.val(scope.searchStr);
	            });
	          }
	        } else if (which === KEY_TAB) {
	          if (scope.results && scope.results.length > 0 && scope.showDropdown) {
	            if (scope.currentIndex === -1 && scope.overrideSuggestions) {
	              // intentionally not sending event so that it does not
	              // prevent default tab behavior
	              handleOverrideSuggestions();
	            }
	            else {
	              if (scope.currentIndex === -1) {
	                scope.currentIndex = 0;
	              }
	              scope.selectResult(scope.results[scope.currentIndex]);
	              scope.$digest();
	            }
	          }
	          else {
	            // no results
	            // intentionally not sending event so that it does not
	            // prevent default tab behavior
	            if (scope.searchStr && scope.searchStr.length > 0) {
	              handleOverrideSuggestions();
	            }
	          }
	        } else if (which === KEY_ES) {
	          // This is very specific to IE10/11 #272
	          // without this, IE clears the input text
	          event.preventDefault();
	        }
	      }
	
	      function httpSuccessCallbackGen(str) {
	        return function(responseData, status, headers, config) {
	          // normalize return obejct from promise
	          if (!status && !headers && !config && responseData.data) {
	            responseData = responseData.data;
	          }
	          scope.searching = false;
	          processResults(
	            extractValue(responseFormatter(responseData), scope.remoteUrlDataField),
	            str);
	        };
	      }
	
	      function httpErrorCallback(errorRes, status, headers, config) {
	        scope.searching = httpCallInProgress;
	
	        // normalize return obejct from promise
	        if (!status && !headers && !config) {
	          status = errorRes.status;
	        }
	
	        // cancelled/aborted
	        if (status === 0 || status === -1) { return; }
	        if (scope.remoteUrlErrorCallback) {
	          scope.remoteUrlErrorCallback(errorRes, status, headers, config);
	        }
	        else {
	          if (console && console.error) {
	            console.error('http error');
	          }
	        }
	      }
	
	      function cancelHttpRequest() {
	        if (httpCanceller) {
	          httpCanceller.resolve();
	        }
	      }
	
	      function getRemoteResults(str) {
	        var params = {},
	            url = scope.remoteUrl + encodeURIComponent(str);
	        if (scope.remoteUrlRequestFormatter) {
	          params = {params: scope.remoteUrlRequestFormatter(str)};
	          url = scope.remoteUrl;
	        }
	        if (!!scope.remoteUrlRequestWithCredentials) {
	          params.withCredentials = true;
	        }
	        cancelHttpRequest();
	        httpCanceller = $q.defer();
	        params.timeout = httpCanceller.promise;
	        httpCallInProgress = true;
	        $http.get(url, params)
	          .then(httpSuccessCallbackGen(str))
	          .catch(httpErrorCallback)
	          .finally(function(){httpCallInProgress=false;});
	      }
	
	      function getRemoteResultsWithCustomHandler(str) {
	        cancelHttpRequest();
	
	        httpCanceller = $q.defer();
	
	        scope.remoteApiHandler(str, httpCanceller.promise)
	          .then(httpSuccessCallbackGen(str))
	          .catch(httpErrorCallback);
	
	        /* IE8 compatible
	        scope.remoteApiHandler(str, httpCanceller.promise)
	          ['then'](httpSuccessCallbackGen(str))
	          ['catch'](httpErrorCallback);
	        */
	      }
	
	      function clearResults() {
	        scope.showDropdown = false;
	        scope.results = [];
	        if (dd) {
	          dd.scrollTop = 0;
	        }
	      }
	
	      function initResults() {
	        scope.showDropdown = displaySearching;
	        scope.currentIndex = scope.focusFirst ? 0 : -1;
	        scope.results = [];
	      }
	
	      function getLocalResults(str) {
	        var i, match, s, value,
	            searchFields = scope.searchFields.split(','),
	            matches = [];
	        if (typeof scope.parseInput() !== 'undefined') {
	          str = scope.parseInput()(str);
	        }
	        for (i = 0; i < scope.localData.length; i++) {
	          match = false;
	
	          for (s = 0; s < searchFields.length; s++) {
	            value = extractValue(scope.localData[i], searchFields[s]) || '';
	            match = match || (value.toString().toLowerCase().indexOf(str.toString().toLowerCase()) >= 0);
	          }
	
	          if (match) {
	            matches[matches.length] = scope.localData[i];
	          }
	        }
	        return matches;
	      }
	
	      function checkExactMatch(result, obj, str){
	        if (!str) { return false; }
	        for(var key in obj){
	          if(obj[key].toLowerCase() === str.toLowerCase()){
	            scope.selectResult(result);
	            return true;
	          }
	        }
	        return false;
	      }
	
	      function searchTimerComplete(str) {
	        // Begin the search
	        if (!str || str.length < minlength) {
	          return;
	        }
	        if (scope.localData) {
	          scope.$apply(function() {
	            var matches;
	            if (typeof scope.localSearch() !== 'undefined') {
	              matches = scope.localSearch()(str, scope.localData);
	            } else {
	              matches = getLocalResults(str);
	            }
	            scope.searching = false;
	            processResults(matches, str);
	          });
	        }
	        else if (scope.remoteApiHandler) {
	          getRemoteResultsWithCustomHandler(str);
	        } else {
	          getRemoteResults(str);
	        }
	      }
	
	      function processResults(responseData, str) {
	        var i, description, image, text, formattedText, formattedDesc;
	
	        if (responseData && responseData.length > 0) {
	          scope.results = [];
	
	          for (i = 0; i < responseData.length; i++) {
	            if (scope.titleField && scope.titleField !== '') {
	              text = formattedText = extractTitle(responseData[i]);
	            }
	
	            description = '';
	            if (scope.descriptionField) {
	              description = formattedDesc = extractValue(responseData[i], scope.descriptionField);
	            }
	
	            image = '';
	            if (scope.imageField) {
	              image = extractValue(responseData[i], scope.imageField);
	            }
	
	            if (scope.matchClass) {
	              formattedText = findMatchString(text, str);
	              formattedDesc = findMatchString(description, str);
	            }
	
	            scope.results[scope.results.length] = {
	              title: formattedText,
	              description: formattedDesc,
	              image: image,
	              originalObject: responseData[i]
	            };
	          }
	
	        } else {
	          scope.results = [];
	        }
	
	        if (scope.autoMatch && scope.results.length === 1 &&
	            checkExactMatch(scope.results[0],
	              {title: text, desc: description || ''}, scope.searchStr)) {
	          scope.showDropdown = false;
	        } else if (scope.results.length === 0 && !displayNoResults) {
	          scope.showDropdown = false;
	        } else {
	          scope.showDropdown = true;
	        }
	      }
	
	      function showAll() {
	        if (scope.localData) {
	          scope.searching = false;
	          processResults(scope.localData, '');
	        }
	        else if (scope.remoteApiHandler) {
	          scope.searching = true;
	          getRemoteResultsWithCustomHandler('');
	        }
	        else {
	          scope.searching = true;
	          getRemoteResults('');
	        }
	      }
	
	      scope.onFocusHandler = function() {
	        if (scope.focusIn) {
	          scope.focusIn();
	        }
	        if (minlength === 0 && (!scope.searchStr || scope.searchStr.length === 0)) {
	          scope.currentIndex = scope.focusFirst ? 0 : scope.currentIndex;
	          scope.showDropdown = true;
	          showAll();
	        }
	      };
	
	      scope.hideResults = function() {
	        if (mousedownOn &&
	            (mousedownOn === scope.id + '_dropdown' ||
	             mousedownOn.indexOf('angucomplete') >= 0)) {
	          mousedownOn = null;
	        }
	        else {
	          hideTimer = $timeout(function() {
	            clearResults();
	            scope.$apply(function() {
	              if (scope.searchStr && scope.searchStr.length > 0) {
	                inputField.val(scope.searchStr);
	              }
	            });
	          }, BLUR_TIMEOUT);
	          cancelHttpRequest();
	
	          if (scope.focusOut) {
	            scope.focusOut();
	          }
	
	          if (scope.overrideSuggestions) {
	            if (scope.searchStr && scope.searchStr.length > 0 && scope.currentIndex === -1) {
	              handleOverrideSuggestions();
	            }
	          }
	        }
	      };
	
	      scope.resetHideResults = function() {
	        if (hideTimer) {
	          $timeout.cancel(hideTimer);
	        }
	      };
	
	      scope.hoverRow = function(index) {
	        scope.currentIndex = index;
	      };
	
	      scope.selectResult = function(result) {
	        // Restore original values
	        if (scope.matchClass) {
	          result.title = extractTitle(result.originalObject);
	          result.description = extractValue(result.originalObject, scope.descriptionField);
	        }
	
	        if (scope.clearSelected) {
	          scope.searchStr = null;
	        }
	        else {
	          scope.searchStr = result.title;
	        }
	        callOrAssign(result);
	        clearResults();
	      };
	
	      scope.inputChangeHandler = function(str) {
	        if (str.length < minlength) {
	          cancelHttpRequest();
	          clearResults();
	        }
	        else if (str.length === 0 && minlength === 0) {
	          showAll();
	        }
	
	        if (scope.inputChanged) {
	          str = scope.inputChanged(str);
	        }
	        return str;
	      };
	
	      // check required
	      if (scope.fieldRequiredClass && scope.fieldRequiredClass !== '') {
	        requiredClassName = scope.fieldRequiredClass;
	      }
	
	      // check min length
	      if (scope.minlength && scope.minlength !== '') {
	        minlength = parseInt(scope.minlength, 10);
	      }
	
	      // check pause time
	      if (!scope.pause) {
	        scope.pause = PAUSE;
	      }
	
	      // check clearSelected
	      if (!scope.clearSelected) {
	        scope.clearSelected = false;
	      }
	
	      // check override suggestions
	      if (!scope.overrideSuggestions) {
	        scope.overrideSuggestions = false;
	      }
	
	      // check required field
	      if (scope.fieldRequired && ctrl) {
	        // check initial value, if given, set validitity to true
	        if (scope.initialValue) {
	          handleRequired(true);
	        }
	        else {
	          handleRequired(false);
	        }
	      }
	
	      scope.inputType = attrs.type ? attrs.type : 'text';
	
	      // set strings for "Searching..." and "No results"
	      scope.textSearching = attrs.textSearching ? attrs.textSearching : TEXT_SEARCHING;
	      scope.textNoResults = attrs.textNoResults ? attrs.textNoResults : TEXT_NORESULTS;
	      displaySearching = scope.textSearching === 'false' ? false : true;
	      displayNoResults = scope.textNoResults === 'false' ? false : true;
	
	      // set max length (default to maxlength deault from html
	      scope.maxlength = attrs.maxlength ? attrs.maxlength : MAX_LENGTH;
	
	      // register events
	      inputField.on('keydown', keydownHandler);
	      inputField.on('keyup compositionend', keyupHandler);
	
	      // set response formatter
	      responseFormatter = callFunctionOrIdentity('remoteUrlResponseFormatter');
	
	      // set isScrollOn
	      $timeout(function() {
	        var css = getComputedStyle(dd);
	        isScrollOn = css.maxHeight && css.overflowY === 'auto';
	      });
	    }
	
	    return {
	      restrict: 'EA',
	      require: '^?form',
	      scope: {
	        selectedObject: '=',
	        selectedObjectData: '=',
	        disableInput: '=',
	        initialValue: '=',
	        localData: '=',
	        localSearch: '&',
	        remoteUrlRequestFormatter: '=',
	        remoteUrlRequestWithCredentials: '@',
	        remoteUrlResponseFormatter: '=',
	        remoteUrlErrorCallback: '=',
	        remoteApiHandler: '=',
	        id: '@',
	        type: '@',
	        placeholder: '@',
	        textSearching: '@',
	        textNoResults: '@',
	        remoteUrl: '@',
	        remoteUrlDataField: '@',
	        titleField: '@',
	        descriptionField: '@',
	        imageField: '@',
	        inputClass: '@',
	        pause: '@',
	        searchFields: '@',
	        minlength: '@',
	        matchClass: '@',
	        clearSelected: '@',
	        overrideSuggestions: '@',
	        fieldRequired: '=',
	        fieldRequiredClass: '@',
	        inputChanged: '=',
	        autoMatch: '@',
	        focusOut: '&',
	        focusIn: '&',
	        fieldTabindex: '@',
	        inputName: '@',
	        focusFirst: '@',
	        parseInput: '&'
	      },
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || TEMPLATE_URL;
	      },
	      compile: function(tElement) {
	        var startSym = $interpolate.startSymbol();
	        var endSym = $interpolate.endSymbol();
	        if (!(startSym === '{{' && endSym === '}}')) {
	          var interpolatedHtml = tElement.html()
	            .replace(/\{\{/g, startSym)
	            .replace(/\}\}/g, endSym);
	          tElement.html(interpolatedHtml);
	        }
	        return link;
	      }
	    };
	  }]);
	
	}));


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(17);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(19);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(21);
	
	var _router = __webpack_require__(22);
	
	var _auth = __webpack_require__(23);
	
	var _user = __webpack_require__(26);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('connectwellApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.constants', []).constant('appConfig', __webpack_require__(18)).name;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin']
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(24);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(28);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(32);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(34);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(36);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default, _signup2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(29),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go(referrer);
	    }]
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(30),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(31),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Login</h1>\n      <p>Accounts are reset on server restart from <code>server/config/seed.js</code>. Default account is <code>test@example.com</code> / <code>test</code></p>\n      <p>Admin account is <code>admin@example.com</code> / <code>admin</code></p>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\" required>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required>\n        </div>\n\n        <div class=\"form-group has-error\">\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">\n             Please enter your email and password.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n             Please enter a valid email.\n          </p>\n\n          <p class=\"help-block\">{{ vm.errors.login }}</p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-login\" type=\"submit\">\n            Login\n          </button>\n          <a class=\"btn btn-default btn-lg btn-register\" ui-sref=\"signup\">\n            Register\n          </a>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Sign up</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && vm.submitted,\n                                            'has-error': form.name.$invalid && vm.submitted }\">\n          <label>Name</label>\n\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.user.name\"\n                 required/>\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">\n            A name is required\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\n                                            'has-error': form.email.$invalid && vm.submitted }\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n            Doesn't look like a valid email.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\n            What's your email address?\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\n            {{ vm.errors.email }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\n                                            'has-error': form.password.$invalid && vm.submitted }\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\n                 ng-minlength=\"3\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\"\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\n            Password must be at least 3 characters.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\n          <label>Confirm Password</label>\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.password\"\n                 ng-minlength=\"3\" required/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-register\" type=\"submit\">\n            Sign up\n          </button>\n          <a class=\"btn btn-default btn-lg btn-login\" ui-sref=\"login\">\n            Login\n          </a>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Change Password</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Current Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>New Password</label>\n\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required/>\n          <p class=\"help-block\"\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n            Password must be at least 3 characters.\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Confirm New Password</label>\n\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required=\"\"/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n\n        </div>\n\n        <p class=\"help-block\"> {{ vm.message }} </p>\n\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(33);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state'];
	  function LoginController(Auth, $state) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(LoginController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(35);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(37);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser({
	          name: this.user.name,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          if (err.name) {
	            _angular2.default.forEach(err.fields, function (error, field) {
	              form[field].$setValidity('mongoose', false);
	              _this.errors[field] = err.message;
	            });
	          }
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(39);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(41);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('connectwellApp.admin', ['connectwellApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(40),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function () {
	
	  /*@ngInject*/
	  AdminController.$inject = ['User'];
	  function AdminController(User) {
	    _classCallCheck(this, AdminController);
	
	    this.users = User.query();
	  }
	
	  _createClass(AdminController, [{
	    key: 'delete',
	    value: function _delete(user) {
	      user.$remove();
	      this.users.splice(this.users.indexOf(user), 1);
	    }
	  }]);
	
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NavbarComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = function () {
	    NavbarComponent.$inject = ['Auth', '$state', '$anchorScroll', 'searchService', '$location', '$http', '$scope'];
	    function NavbarComponent(Auth, $state, $anchorScroll, searchService, $location, $http, $scope) {
	        'ngInject';
	
	        _classCallCheck(this, NavbarComponent);
	
	        this.menu = [{
	            title: 'Home',
	            state: 'main'
	        }];
	        this.isCollapsed = true;
	        this.isLoggedIn = Auth.isLoggedInSync;
	        this.isAdmin = Auth.isAdminSync;
	        this.getCurrentUser = Auth.getCurrentUserSync;
	        this.$anchorScroll = $anchorScroll;
	        this.$state = $state;
	        this.searchService = searchService;
	        this.$location = $location;
	        this.$http = $http;
	        this.$scope = $scope;
	    }
	
	    _createClass(NavbarComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                console.log(key, ' is the key in nav');
	                this.$location.search('key', key);
	            }
	
	            if (this.$location.search().key) {
	                key = this.$location.search().key;
	                console.log(key);
	                this.searchService.setKey(key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	            });
	
	            if (this.$state.current.name === '') {
	                console.log('this is main');
	            }
	        }
	    }, {
	        key: 'loadCollection',
	        value: function loadCollection(type) {
	            console.log(this.$state.current.name);
	            if (this.$state.current.name === '' || this.$state.current.name === 'main') {
	                console.log('this is the main view');
	                this.$location.url('/#' + type);
	                this.$anchorScroll(type);
	                if (this.searchService.getKey()) {
	                    this.key = this.searchService.getKey();
	                    console.log(this.key);
	                    this.$location.search('key', this.key);
	                }
	            } else {
	                this.$location.url('/#' + type);
	                this.$anchorScroll(type);
	            }
	        }
	    }]);
	
	    return NavbarComponent;
	}();
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	    template: __webpack_require__(43),
	    controller: NavbarComponent
	}).name;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-expand-lg navbar-dark bg-primary fixed-top\" id=\"sideNav\" ng-show=\"client.hasNavigation === 1\">\n    <a class=\"navbar-brand js-scroll-trigger nav-item\" ng-click=\"$ctrl.loadCollection('home')\">\n        <span class=\"d-block d-lg-none\">ConnectWell</span>\n        <span class=\"d-none d-lg-block\" style=\"height:110px;\">\n    <img class=\"img-fluid img-profile mx-auto mb-2\" src=\"./../../assets/images/logo/ConnectWell_logo_White_No_Tag_line.png\" alt=\"\">\n  </span>\n    </a>\n    <div class=\"txtNew d-none d-lg-block\">\n        <span style=\"font-family:arial,ms pgothic,dotum,helvetica,sans-serif;font-size:14px;color:white;\">Integrating Wellness into Life ®</span>\n    </div>\n    <button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n  <span class=\"navbar-toggler-icon\"></span>\n</button>\n    <div class=\"nav-spacer\"></div>\n    <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\n        <ul class=\"navbar-nav\">\n            <!-- <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" href=\"http://connectwell.biz\" target=\"_blank\"><span style=\"color:white;\">Connectwell Home</span></a>\n            </li> -->\n            <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" ng-click=\"$ctrl.loadCollection('articles')\"><span style=\"color:white;\">Health Information Library</span></a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" ng-click=\"$ctrl.loadCollection('initiatives')\"><span style=\"color:white;\">Wellness Initiatives</span></a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" ng-click=\"$ctrl.loadCollection('recipes')\"><span style=\"color:white;\">Healthy Recipe Collection</span></a>\n            </li>\n            <li ng-show=\"$ctrl.isLoggedIn()\">\n                <p class=\"navbar-text\">Hello {{ $ctrl.getCurrentUser().name }}</p>\n            </li>\n            <!-- <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" href=\"#skills\">Skills</a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" href=\"#interests\">Interests</a>\n            </li>\n            <li class=\"nav-item\">\n                <a class=\"nav-link js-scroll-trigger\" href=\"#awards\">Awards</a>\n            </li> -->\n        </ul>\n    </div>\n</nav>"

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FooterComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function () {
	    /*@ngInject*/
	    FooterComponent.$inject = ['$http', '$scope', 'searchService'];
	    function FooterComponent($http, $scope, searchService) {
	        _classCallCheck(this, FooterComponent);
	
	        this.$http = $http;
	        this.$scope = $scope;
	        this.feedback = {};
	        this.failed = false;
	        this.success = false;
	        this.savingSpinner = false;
	        this.searchService = searchService;
	    }
	
	    _createClass(FooterComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            this.getCopyright('Standards of Care');
	        }
	    }, {
	        key: 'showModal',
	        value: function showModal(index) {
	            this.activeTab = index;
	            $('#myModal').modal();
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'submitFeedback',
	        value: function submitFeedback($form) {
	            var _this2 = this;
	
	            console.log($form.$valid);
	            this.savingSpinner = true;
	            console.log(this.feedback);
	            if ($form.$valid) {
	
	                this.$http.post('/api/users/feedback', this.feedback).then(function (response) {
	                    _this2.savingSpinner = false;
	                    console.log(response);
	                    _this2.feedback = {};
	                    _this2.success = true;
	                    _this2.failed = false;
	                    console.log(_this2.savingSpinner);
	                }).catch(function (err) {
	                    _this2.savingSpinner = false;
	                    console.log(err);
	                    _this2.success = false;
	                    _this2.failed = true;
	                });
	            } else {
	                this.failed = true;
	                this.success = false;
	            }
	        }
	    }]);
	
	    return FooterComponent;
	}();
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	    template: __webpack_require__(45),
	    controller: FooterComponent
	}).name;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\" style=\"border-top: 1px solid #dee2e6;padding-top:10px;\">\n    <div class=\"row\" style=\"padding-left:20px;padding-right:20px;\">\n        <div class=\"col-lg-6 col-md-8 col-sm-8\" style=\"margin:auto;padding-top:5px;font-size:12px;\">\n            <p>\n                This information is not intended to provide advice on personal medical matters or to substitute for consultation with a physician. Translation of the English version of this information into other languages is done using machine translation. ConnectWell does not claim accuracy for the translation. Your use of this information means that you agree to the <a style=\"font-size:10px;font-weight: normal\" href=\"#\"\n                    ng-click=\"$ctrl.showModal(0)\">Terms of Use</a> and <a href=\"#\" ng-click=\"$ctrl.showModal(1)\" style=\"font-size:10px;\">Privacy Policy</a>. To report any issues or problems with the site, let us know by using our <a style=\"font-size:10px;font-weight: normal\"\n                    href=\"#\" ng-click=\"$ctrl.showModal(2)\">Feedback Form</a>. {{copyrightCW}} – Integrating Wellness into Life®.\n            </p>\n        </div>\n    </div>\n</div>\n\n<!-- Modal -->\n<div class=\"modal fade\" style=\"width:100% !important;\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\n    <div class=\"modal-dialog modal-lg\" style=\"width:100%;\" role=\"document\">\n        <div class=\"modal-content\" style=\"width:100%; !important;\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\" id=\"myModalLabel\">{{policysearchCtrl.modal.policy}}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height:auto;\">\n                <uib-tabset active=\"$ctrl.activeTab\" justified=\"true\" ng-class=\"{fundingTab : policysearchCtrl.modal.category === 'Funding Housing Affordability'}\">\n                    <uib-tab index=\"0\" style=\"height:100%;\">\n                        <uib-tab-heading>\n                            <!-- Summary and <br> Benefits -->\n                            Terms of Use<br>\n                        </uib-tab-heading>\n                        <uib-tab-body class=\"tab-list\">\n                            <div data-packed=\"true\" style=\"padding:30px;\" id=\"comp-jm29v3gz\">\n                                <p class=\"font_8\">This Terms of Use applies to all of ConnectWell’s sites (marketing website and content site). By using this site (the “Site”), you agree to these Terms of Use. If you do not agree to all of these Terms of Use of use, do not use this site.</p>\n\n                                <p class=\"font_8\" style=\"text-align:center;\">&nbsp;</p>\n\n                                <p class=\"font_8\" style=\"text-align:center;\"><span style=\"color:#F79330;\"><span style=\"font-size:15px;\">The Site Does Not Provide Medical Advice</span></span>\n                                </p>\n\n\n\n                                <p class=\"font_8\">The contents of the Site, including articles, images, recipes, information obtained from ConnectWell's licensors and all other material (\"Content\") are for informational purposes only. The Content is not intended to be\n                                    a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition. Never\n                                    disregard professional medical advice or delay in seeking it because of something you have read on the Site.&nbsp;You can only use the Site, view and print materials if your company is a ConnectWell customer and has\n                                    a license to use the Site.</p>\n\n\n\n                                <p class=\"font_8\">If you think you may have a medical emergency, call your doctor or 911 immediately.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">Use of Materials</span></span>\n                                </p>\n\n                                <p class=\"font_8\">You agree that the Site contains proprietary content, information and/or materials that are owned by ConnectWell and its licensors and is protected by applicable intellectual property and other laws. Any use not expressly permitted by these Terms of Use may be unlawful.</p>\n\n\n\n                                <p class=\"font_8\">All materials posted on this Site are protected by the copyright laws of the United States and other countries. ConnectWell authorizes you to view and print the Content solely for your personal, noncommercial use. You may\n                                    not copy or otherwise download the Content.</p>\n\n\n\n                                <p class=\"font_8\">Title to the materials remains with ConnectWell or its licensors. Any use of the materials not expressly permitted by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark, and other\n                                    laws. All rights not expressly granted herein are reserved to ConnectWell and its licensors.</p>\n\n\n\n                                <p class=\"font_8\">If you violate any of these Terms of Use, your permission to use the materials automatically terminates.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Changes to this Agreement</span></span><br> ConnectWell reserves the right to change these Terms of Use from time to time. You agree that we may notify you of\n                                    these changes by posting them on the Site. Your continued use of the Site will be deemed acceptance of the modified Agreement. Any changes to the Terms of Use will be effective as of the date they are posted, so, please\n                                    review this Agreement not only before using the Site for the first time but frequently thereafter.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">Liability of ConnectWell and Its Licensors</span></span>\n                                </p>\n\n                                <p class=\"font_8\">The use of the ConnectWell Site and the Content is at your own risk.</p>\n\n\n\n                                <p class=\"font_8\">The Site and the content are provided on an \"as is\" basis. CONNECTWELL AND ITS LICENSORS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,\n                                    NON-INFRINGEMENT OF THIRD PARTIES' RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE.</p>\n\n\n\n                                <p class=\"font_8\">Without limiting the foregoing, ConnectWell, its licensors, and its suppliers make no representations or warranties about the following the accuracy, reliability, completeness or timeliness of the Content.</p>\n\n\n\n                                <p class=\"font_8\">In no event shall ConnectWell or its licensors, or any third parties mentioned on the Site, be liable for any damages (including, without limitation, incidental and consequential damages, personal injury/wrongful death,\n                                    lost profits, or damages resulting from lost data or business interruption) resulting from the use of or inability to use the Site or the Content, whether based on warranty, contract, tort, or any other legal theory,\n                                    and whether or not ConnectWell, its suppliers, or any third parties mentioned on the Site are advised of the possibility of such damages. ConnectWell, its licensors, and any third parties mentioned on the ConnectWell\n                                    Site shall be liable only to the extent of actual damages incurred by you, not to exceed $100.&nbsp; ConnectWell, its licensors, and any third parties mentioned on the Site are not liable for any personal injury, including\n                                    death, caused by your use or misuse of the Site or the Content. &nbsp;&nbsp;</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Advertisements, Searches, and Links to Other Sites</span></span>\n                                </p>\n\n                                <p class=\"font_8\">ConnectWell may provide links to third-party web sites. ConnectWell does not recommend and does not endorse the content on any third-party websites. ConnectWell is not responsible for the content of linked third-party sites,\n                                    and does not make any representations regarding their content or accuracy. Your use of third-party websites is at your own risk and subject to the terms of Use of use for such sites.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Indemnity</span></span>\n                                </p>\n\n                                <p class=\"font_8\">You agree to defend, indemnify, and hold ConnectWell, its officers, directors, employees, agents, licensors, and suppliers, harmless from and against any claims, actions or demands, liabilities and settlements including\n                                    without limitation, reasonable legal and accounting fees, resulting from, or alleged to result from, your violation of these Terms.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Miscellaneous</span></span>\n                                </p>\n\n                                <p class=\"font_8\">You expressly agree that exclusive jurisdiction for any dispute relating to your use of the Site resides in the state court in the State of California governed by the laws of the State of California, without respect to\n                                    its conflict of laws principles. If any provision of these Terms of Use is found to be invalid by any court having competent jurisdiction, the invalidity of that provision shall not affect the validity of the remaining\n                                    provisions, which shall remain in full force. No waiver of any of these Terms of Use shall be deemed a further or continuing waiver.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">Notice and Takedown Procedures; and Copyright Agent</span></span>\n                                </p>\n\n                                <p class=\"font_8\">If you believe any materials accessible on or from the Site infringe your copyright, you may request removal of those materials (or access thereto) from this web site by contacting ConnectWell's copyright agent (identified\n                                    below) and providing the following information:</p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span class=\"wixGuard\">​</span></p>\n\n                                <ol class=\"font_8\">\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">Identification of the copyrighted work that you believe to be infringed. Please describe the work, and where possible include a copy or the location (e.g., URL) of an authorized version of the work.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">Identification of the material that you believe to be infringing and its location. Please describe the material, and provide us with its URL or any other pertinent information that will allow us to locate the material.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">Your name, address, telephone number and (if available) e-mail address.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">A statement that you have a good faith belief that the complained of use of the materials is not authorized by the copyright owner, its agent, or the law.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">A statement that the information that you have supplied is accurate, and indicating that \"under penalty of perjury,\" you are the copyright owner or are authorized to act on the copyright owner's behalf.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\" style=\"margin-left:40px;\">A signature or the electronic equivalent from the copyright holder or authorized representative.</p>\n                                    </li>\n                                </ol>\n\n\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">ConnectWell's agent for copyright issues relating to this Site is as follows:</span></span>\n                                </p>\n\n                                <p class=\"font_8\"><span style=\"color:#F79330;\"><span class=\"wixGuard\">​</span></span>\n                                </p>\n\n                                <p class=\"font_8\">ConnectWell, Inc.<br> Attn: General Counsel</p>\n\n                                <p class=\"font_8\">P.O. Box 444</p>\n\n                                <p class=\"font_8\">Pleasanton, CA 94566<br>\n                                    <br> EMAIL: <object height=\"0\"><a class=\"auto-generated-link\" data-auto-recognition=\"true\" data-content=\"info@connectwell.health\" href=\"mailto:info@connectwell.health\" data-type=\"mail\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></object></p>\n\n\n\n                                <p class=\"font_8\">Complete Agreement</p>\n\n                                <p class=\"font_8\">These Terms of Use and the&nbsp;ConnectWell Privacy Policy&nbsp;constitute the entire agreement between you and ConnectWell with respect to the use of the Site and the Content.</p>\n\n\n                                <p class=\"font_8\">ConnectWell Policy&nbsp;Last updated on&nbsp;December 29, 2022</p>\n                            </div>\n\n                        </uib-tab-body>\n\n\n                    </uib-tab>\n                    <uib-tab index=\"1\" select=\"policysearchCtrl.loadFilteredMap(policysearchCtrl.modal); policysearchCtrl.updateJusridictionTable()\" ng-hide=\"policysearchCtrl.modal.policy === 'Housing Accountability Act' || policysearchCtrl.modal.policy === 'Accessory Dwelling Units'\">\n                        <uib-tab-heading>\n                            <!-- Who <br> Implements -->\n                            Privacy Policy\n                        </uib-tab-heading>\n                        <uib-tab-body class=\"tab-list\">\n                            <div data-packed=\"true\" style=\"padding:30px;\" class=\"txtNew\" id=\"comp-jm2av4hu\">\n                                <p class=\"font_8\" style=\"font-size:15px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\"><span style=\"font-size:15px;\">Introduction</span></span>\n                                    </span>\n                                </p>\n\n                                <p class=\"font_8\">This Privacy Policy applies to all of ConnectWell’s sites (marketing website and content site). Welcome to ConnectWell’s Site. We provide health and wellness information to companies that subscribe to our services. We care about the privacy of our users and this Privacy Policy (the “Policy”) describes how ConnectWell,\n                                    Inc. (“we,” “us,” or “our”) collects, uses, and discloses the information we obtain from you and about your use of our website.<br> &nbsp;\n                                </p>\n\n                                <p class=\"font_8\" style=\"text-align:center;\"><span style=\"color:#F79330;\">BEFORE USING THE SERVICES PLEASE READ THIS PRIVACY POLICY CAREFULLY. </span></p>\n\n\n\n                                <p class=\"font_8\">By accessing and using the Services you agree to the terms of this Privacy Policy. Do not use the Services if you do not agree to all of the terms of this Privacy Policy.</p>\n\n\n\n                                <p class=\"font_8\">If you are accessing ConnectWell Services through a website or portal hosted by an organization or hosting service that is not ConnectWell, the Privacy Policy of that organization's website, portal or hosting service will\n                                    apply to your use and you should review it.</p>\n\n\n                                </p>\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\"><span style=\"background-color:#FFFFFE;\">Definitions</span></span>\n                                    </span><br> “Client User” means an entity who has licensed the Service directly from ConnectWell, or sub-licensed it through an authorized ConnectWell sublicensor.<br>\n                                    <br> “Content” means the health and wellness information.</p>\n\n                                <p class=\"font_8\">“End User” means a consumer, patient, member, employee, or other individual receiving access to the Services from a Client User.</p>\n\n                                <p class=\"font_8\">“Service(s)” means collectively the Site and Content.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">Information We Collect</span></span>\n                                </p>\n\n                                <p class=\"font_8\">We collect information on End Users’ usage of the Service. Usage Activity may include but is not limited to:</p>\n\n                                <ul class=\"font_8\" style=\"margin-left:40px;\">\n                                    <li>\n                                        <p class=\"font_8\">Terms you search for</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">Content you review</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">Categories within the Content that you spend time on</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">Views and interactions with Content</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">Activity from Client User that prompted views of Content</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">Frequency of use</p>\n                                    </li>\n                                </ul>\n\n\n\n                                <p class=\"font_8\">ConnectWell aggregates usage information of End Users to analyze, measure and assess user behaviors, trends and outcomes and the performance, usefulness, benefits and value of the Services. ConnectWell also aggregates information\n                                    collected for the Service’s development and improvement purposes and to conduct and assess client and customer benchmarking activities. ConnectWell also uses information collected to prevent, detect and investigate\n                                    fraud, security breaches, potentially prohibited or illegal activities and to enforce the ConnectWell Terms of Use for the Services, or other applicable policies.</p>\n\n                                <p class=\"font_8\">For Client Users, we collect a client user contact name, email address, and similar identifying information so that we can better serve your organization with the Services to which your company has subscribed.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">Cookies</span></span>\n                                </p>\n\n                                <p class=\"font_8\">ConnectWell uses various data collection tools such as cookies, web beacons, server logs and other tools to understand website user behavior and preferences, improve our website users' experiences, and manage our content.\n                                    Cookies are text files that contain pieces of information that a website transfers to an individual's hard drive for record-keeping purposes. A cookie is created when an individual views or uses the Service. The ConnectWell\n                                    server uses cookies to capture user movement on the site. These are persistent cookies, which remain on your computer to allow ConnectWell to identify your browser, but they are not used to identify you. ConnectWell\n                                    cookies are stored only on your computer, and ConnectWell does not trade, or sell any individual-identifying information generated from cookies. Web beacons are transparent graphic images located on pages of the ConnectWell\n                                    Service. Web beacons allow ConnectWell to capture the actions of website users as they move from page to page. This helps us understand how people navigate through the ConnectWell Service.</p>\n\n\n                                </p>\n\n                                <p class=\"font_8\" style=\"font-size:13px;\"><span style=\"font-size:15px;\"><span style=\"font-weight:bold;\"><span style=\"color:#5998D1;\">How We Use Your Information</span></span>\n                                    </span>\n                                </p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">To provide our Services&nbsp;</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">ConnectWell uses the information it collects about your usage to provide the Service and support the Service.</p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">To maintain and improve our Services</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">ConnectWell also uses such information to evaluate, monitor, improve and enhance its Service and/or create new Services, including the features, functionality, performance and usefulness of the Service.</p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">To communicate with Client Users</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">ConnectWell may use your name and email address to contact you regarding the Services to respond to requests for support.</p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Use of cookies&nbsp;</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">We use this information to evaluate, monitor and improve the quality of our Service, to analyze trends, conduct benchmarking, and assess the impact of our Service and to promote the value, usefulness and impact of our Service.</p>\n\n\n                                </p>\n\n                                <p class=\"font_8\" style=\"font-size:13px;\"><span style=\"font-size:15px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">How We Share Your Information</span></span>\n                                    </span>\n                                </p>\n\n                                <p class=\"font_8\">Except as described below, ConnectWell does not share, trade or sell information we collect about you and your usage.</p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Sharing of Anonymous De-identified Information</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">ConnectWell may share and disclose aggregate and/or de-identified information collected on you and your usage of the Service externally to third parties, including the public, in order to promote and market the Service\n                                    and demonstrate the benefits, value, usefulness, outcomes, and performance of the Service. ConnectWell may also share and disclose collected information which it aggregates or de-identifies, along with its analysis\n                                    and assessment of such information, externally to third parties, including the public, for the following purposes: informational, promotional, marketing, and client and customer benchmarking purposes. Such aggregated\n                                    information is non-personally identifiable information.</p>\n\n\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">In Response to Legal Process</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">It is possible that we may need to disclose personal information when required by law, such as responses to civil or criminal subpoenas, or other requests by law enforcement personnel. We will disclose such information\n                                    only when we have a good-faith belief that it is necessary to comply with a court order, ongoing judicial proceeding, subpoena, or other legal process, or to exercise our legal rights or defend against legal claims.\n                                    Unless otherwise prohibited by law, we will seek to notify affected users prior to sharing any personal information.</p>\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\"><span class=\"wixGuard\">​</span></span>\n                                    </span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">As Part of a Sale or Merger</span></span>\n                                </p>\n\n                                <p class=\"font_8\" style=\"margin-left:40px;\">We may disclose your personal information as part of a reorganization or a sale of ConnectWell. Any third party to which we transfer our assets will be required to use your personal information only as described in this\n                                    Policy.\n                                </p>\n\n                                <p class=\"font_8\"><span style=\"color:#F79330;\"><span class=\"wixGuard\">​</span></span>\n                                </p>\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Security</span></span>\n                                </p>\n\n                                <p class=\"font_8\">We work hard to protect you from unauthorized access, alteration, disclosure, or destruction of information we hold, and use the following measures:</p>\n\n                                <ul class=\"font_8\" style=\"margin-left:40px;\">\n                                    <li>\n                                        <p class=\"font_8\">We use encryption to keep your data private while in transit.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">We review our information collection, storage, and processing practices to prevent unauthorized access to our systems.</p>\n                                    </li>\n                                    <li>\n                                        <p class=\"font_8\">We restrict access to personal information to ConnectWell employees, contractors, and agents who need that information in order to process it. Anyone with this access is subject to strict contractual confidentiality\n                                            obligations and may be disciplined or terminated if they fail to meet these obligations.<br> &nbsp;\n                                        </p>\n                                    </li>\n                                </ul>\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Changes to this Policy</span></span>\n                                </p>\n\n                                <p class=\"font_8\">This Policy is current as of its posted effective date. We may update this policy from time to time and it is your responsibility to check back to review this site regularly for updates. If you have any privacy issues regarding\n                                    any ConnectWell Service, please contact your sponsoring organization or email ConnectWell at info@connectwell.health. If you contact ConnectWell about any privacy issues, you can expect a response from us within approximately\n                                    8 days.</p>\n\n\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Not for Use by Children</span></span>\n                                </p>\n\n                                <p class=\"font_8\">The Service is not intended for use by children. Children under the age of majority in their place of residence may use the Service only with the consent or supervision of a parent or legal guardian.</p>\n\n                                <p class=\"font_8\"><span style=\"font-weight:bold;\"><span class=\"wixGuard\">​</span></span>\n                                </p>\n\n                                <p class=\"font_8\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Contact Us</span></span>\n                                </p>\n\n                                <p class=\"font_8\">If you have any questions about this Policy or our privacy practices, you may reach us at any time by emailing at <object height=\"0\"><a class=\"auto-generated-link\" data-auto-recognition=\"true\" data-content=\"info@connectwell.health\" href=\"mailto:info@connectwell.health\" data-type=\"mail\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></object>                                    or by contacting us at:</p>\n\n\n\n                                <p class=\"font_8\">ConnectWell</p>\n\n                                <p class=\"font_8\">ATTN: Privacy Policy Issues</p>\n\n                                <p class=\"font_8\">P.O. Box 444</p>\n\n                                <p class=\"font_8\">Pleasanton, CA 94566<br> &nbsp;\n                                </p>\n\n                                <p class=\"font_8\">Last updated: December 29, 2022</p>\n\n                                <p class=\"font_8\" style=\"font-size:20px; text-align:center;\"><span style=\"font-size:20px;\"><span style=\"color:#5998D1;\"><span style=\"text-decoration:underline;\"><span style=\"font-weight:bold;\">Privacy Notice for California Residents</span></span></span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Effective Date:</span></span> December 29, 2022</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Last Reviewed on:</span></span> December 29, 2022</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">This<span style=\"color:#5998D1;\"> <span style=\"font-weight:bold;\">Privacy Notice for California Residents</span></span>\n supplements the information contained in our privacy policy above and \napplies solely to all visitors, users, and others who reside in the \nState of California (”consumers” or “you”). We adopt this notice to \ncomply with the California Consumer Privacy Act of 2018 (CCPA) and any \nterms defined in the CCPA have the same meaning when used in this \nnotice.</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Information We Collect</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">Our Website collects \ninformation that identifies, relates to, describes, references, is \ncapable of being associated with, or could reasonably be linked, \ndirectly or indirectly, with a particular consumer or device (”personal \ninformation”). In particular, our Website has collected the following \ncategories of personal information from its consumers within the last \ntwelve (12) months:</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Category A</span>:</span><span style=\"color:#3D9BE9;\"> </span>Identifiers</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Examples:</span></span> A real name, Internet Protocol address, email address, or other similar identifiers.</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Collected</span>:</span> NO</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Category B:</span></span> Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Examples:</span> </span>A\n name, signature, Social Security number, physical characteristics or \ndescription, address, telephone number, passport number, driver’s \nlicense or state identification card number, insurance policy number, \neducation, employment, employment history, bank account number, credit \ncard number, debit card number, or any other financial information, \nmedical information, or health insurance information. Some personal \ninformation included in this category may overlap with other categories.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Collected:</span></span><span style=\"color:#3D9BE9;\"><span style=\"font-weight:bold;\"> </span></span>NO</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Category C:</span></span> Protected classification characteristics under California or federal law.</p>\n\n<p class=\"font_8\" style=\"font-size:13px;\">Examples: Age (40 years or \nolder), race, color, ancestry, national origin, citizenship, religion or\n creed, marital status, medical condition, physical or mental \ndisability, sex (including gender, gender identity, gender expression, \npregnancy or childbirth and related medical conditions), sexual \norientation, veteran or military status, genetic information (including \nfamilial genetic information).</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Collected:</span> </span>NO</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">Personal information does not include:</p>\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Publicly available information from government records.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">De-identified or aggregated consumer information.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Information excluded from the CCPA’s scope, like:</p>\n\n<ul>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">health or medical information \ncovered by the Health Insurance Portability and Accountability Act of \n1996 (HIPAA) and the California Confidentiality of Medical Information \nAct (CMIA) or clinical trial data;</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">personal information covered \nby certain sector-specific privacy laws, including the Fair Credit \nReporting Act (FRCA), the Gramm-Leach-Bliley Act (GLBA) or California \nFinancial Information Privacy Act (FIPA), and the Driver’s Privacy \nProtection Act of 1994.</p>\n</li>\n</ul>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Use of Personal Information</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We may use, or disclose the personal information we collect for one or more of the following business purposes:</p>\n\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">To fulfill or meet the reason \nyou provided the information. For example, if you share your name and \ncontact information to request a price quote or ask a question about our\n products or services, we will use that personal information to respond \nto your inquiry. If you provide your personal information to purchase a \nproduct or service, we will use that information to process your payment\n and facilitate delivery. We may also save your information to \nfacilitate new product orders or process returns.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">To provide you with support \nand to respond to your inquiries, including to investigate and address \nyour concerns and monitor and improve our responses.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">As described to you when collecting your personal information or as otherwise set forth in the CCPA.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">We will not collect additional\n categories of personal information or use the personal information we \ncollected for materially different, unrelated, or incompatible purposes \nwithout providing you notice.</p>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Sharing Personal Information</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We may disclose your personal \ninformation to a third party for a business purpose. When we disclose \npersonal information for a business purpose, we enter a contract that \ndescribes the purpose and requires the recipient to both keep that \npersonal information confidential and not use it for any purpose except \nperforming the contract.</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Disclosures of Personal Information for a Business Purpose</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">In the preceding twelve (12) months, ConnectWell has not disclosed personal information for a business purpose.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Sales of Personal Information</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">ConnectWell does not, and in the preceding twelve (12) months, has not sold personal information.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Your Rights and Choices</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">The CCPA provides consumers \n(California residents) with specific rights regarding their personal \ninformation. This section describes your CCPA rights and explains how to\n exercise those rights.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Access to Specific Information and Data Portability Rights</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">You have the right to request \nthat we disclose certain information to you about our collection and use\n of your personal information over the past 12 months. Once we receive \nand confirm your verifiable consumer request, we will disclose to you:</p>\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">The categories of personal information we collected about you.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">The categories of sources for the personal information we collected about you.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Our business or commercial purpose for collecting or selling that personal information.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">The categories of third parties with whom we share that personal information.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">The specific pieces of personal information we collected about you (also called a data portability request).</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">sales, identifying the personal information categories that each category of recipient purchased; and</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.</p>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Deletion Request Rights</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">You have the right to request \nthat we delete any of your personal information that we collected from \nyou and retained, subject to certain exceptions, by emailing us at <span style=\"text-decoration:underline;\"><a href=\"mailto:info@connectwell.health\" target=\"_self\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></span>.\n Once we receive and confirm your verifiable consumer request, we will \ndelete (and direct our service providers to delete) your personal \ninformation from our records, unless an exception applies.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We may deny your deletion request if retaining the information is necessary for us or our service provider(s) to:</p>\n\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Complete the transaction for \nwhich we collected the personal information, provide a good or service \nthat you requested, take actions reasonably anticipated within the \ncontext of our ongoing business relationship with you, or otherwise \nperform our contract with you.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Detect security incidents, \nprotect against malicious, deceptive, fraudulent, or illegal activity, \nor prosecute those responsible for such activities.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Debug products to identify and repair errors that impair existing intended functionality.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Exercise free speech, ensure \nthe right of another consumer to exercise their free speech rights, or \nexercise another right provided for by law.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.).</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Engage in public or \npeer-reviewed scientific, historical, or statistical research in the \npublic interest that adheres to all other applicable ethics and privacy \nlaws, when the information’s deletion may likely render impossible or \nseriously impair the research’s achievement, if you previously provided \ninformed consent.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Comply with a legal obligation.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Make other internal and lawful uses of that information that are compatible with the context in which you provided it.</p>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Exercising Access, Data Portability, and Deletion Rights</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">To exercise the access, data \nportability, and deletion rights described above, please submit a \nverifiable consumer request to us by sending us a message to <span style=\"text-decoration:underline;\"><a href=\"mailto:info@connectwell.health\" target=\"_self\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></span>.\n Only you, or a person registered with the California Secretary of State\n that you authorize to act on your behalf, may make a verifiable \nconsumer request related to your personal information. You may also make\n a verifiable consumer request on behalf of your minor child.</p>\n\n<p class=\"font_8\" style=\"font-size:13px;\">You may only make a verifiable\n consumer request for access or data portability twice within a 12-month\n period. The verifiable consumer request must:</p>\n\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Provide sufficient information\n that allows us to reasonably verify you are the person about whom we \ncollected personal information or an authorized representative.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.</p>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We cannot respond to your \nrequest or provide you with personal information if we cannot verify \nyour identity or authority to make the request and confirm the personal \ninformation relates to you. We will only use personal information \nprovided in a verifiable consumer request to verify the requestor’s \nidentity or authority to make the request.</p>\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Response Timing and Format</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We endeavor to respond to a \nverifiable consumer request within forty-five (45) days of its receipt. \nIf we require more time (up to 90 days), we will inform you of the \nreason and extension period in writing. We will deliver our written \nresponse by mail or electronically, at your option. Any disclosures we \nprovide will only cover the 12-month period preceding the verifiable \nconsumer request’s receipt. The response we provide will also explain \nthe reasons we cannot comply with a request, if applicable. For data \nportability requests, we will select a format to provide your personal \ninformation that is readily useable and should allow you to transmit the\n information from one entity to another entity without hindrance, \nspecifically by electronic mail communication.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We do not charge a fee to \nprocess or respond to your verifiable consumer request unless it is \nexcessive, repetitive, or manifestly unfounded. If we determine that the\n request warrants a fee, we will tell you why we made that decision and \nprovide you with a cost estimate before completing your request.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Personal Information Sales Opt-Out and Opt-In Rights</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">While ConnectWell does not \nsell any personal information, you have the right, if you are 16 years \nof age or older, to direct us to not sell your personal information at \nany time (the “right to opt-out”). We do not sell the personal \ninformation of consumers we actually know are less than 16 years of age,\n unless we receive affirmative authorization (the “right to opt-in”) \nfrom either the consumer who is between 13 and 16 years of age, or the \nparent or guardian of a consumer less than 13 years of age. Consumers \nwho opt-in to personal information sales may opt-out of future sales at \nany time. To exercise the right to opt-out, you (or your authorized \nrepresentative) may submit a request to us by sending us a message to <span style=\"text-decoration:underline;\"><a href=\"mailto:info@connectwell.health\" target=\"_self\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></span>.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">Once you make an opt-out \nrequest, we will wait at least twelve (12) months before asking you to \nreauthorize personal information sales. However, you may change your \nmind and opt back in to personal information sales at any time by \nvisiting our Website and sending us a message. We will only use personal\n information provided in an opt-out request to review and comply with \nthe request.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\"><span style=\"color:#5998D1;\"><span style=\"font-weight:bold;\">Non-Discrimination</span></span></p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p>\n\n\n<ul class=\"font_8\" style=\"margin-left:40px; font-size:13px;\">\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Deny you goods or services.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Charge you different prices or\n rates for goods or services, including through granting discounts or \nother benefits, or imposing penalties.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Provide you a different level or quality of goods or services.</p>\n</li>\n<li>\n<p class=\"font_8\" style=\"font-size:13px;\">Suggest that you may receive a\n different price or rate for goods or services or a different level or \nquality of goods or services.</p>\n</li>\n</ul>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">However, we may offer you \ncertain financial incentives permitted by the CCPA that can result in \ndifferent prices, rates, or quality levels. Any CCPA-permitted financial\n incentive we offer will reasonably relate to your personal \ninformation’s value and contain written terms that describe the \nprogram’s material aspects. Participation in a financial incentive \nprogram requires your prior opt in consent, which you may revoke at any \ntime.</p>\n\n\n\n<p class=\"font_8\" style=\"font-size:13px;\">California’s “Shine the Light”\n law (Civil Code Section § 1798.83) permits users of our Website that \nare California residents to request certain information regarding our \ndisclosure of personal information to third parties for their direct \nmarketing purposes. To make such a request, please send us an email to <span style=\"text-decoration:underline;\"><a href=\"mailto:info@connectwell.health\" target=\"_self\"><span style=\"font-size: 12px !important;\">info@connectwell.health</span></a></span>.</p>\n\n                            </div>\n                        </uib-tab-body>\n                    </uib-tab>\n                    <uib-tab index=\"2\" heading=\"\">\n                        <uib-tab-heading>\n                            Feedback Form\n                        </uib-tab-heading>\n                        <uib-tab-body class=\"tab-list\">\n                            <div class=\"col-md-12\">\n                                <div class=\"alert alert-success ng-hide\" role=\"alert\" ng-show=\"$ctrl.success\">\n                                    <div class=\"container\">\n                                        <div class=\"alert-icon\">\n                                            <i class=\"now-ui-icons ui-2_like\"></i>\n                                        </div>\n                                        <strong>Thank you!</strong> Your feedback has been submitted and will be reviewed as soon as possible.\n                                        <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n                                          <span aria-hidden=\"true\">\n                                          <i class=\"now-ui-icons ui-1_simple-remove\"></i>\n                                        </span>\n                                      </button>\n                                    </div>\n                                </div>\n                                <!-- Error alert -->\n                                <div class=\"alert alert-danger ng-hide\" role=\"alert\" ng-show=\"$ctrl.failed\">\n                                    <div class=\"container\">\n                                        <div class=\"alert-icon\">\n                                            <i class=\"now-ui-icons objects_support-17\"></i>\n                                        </div>\n                                        <strong>Oops!</strong> Something went wrong. Please fill out all fields and try submitting your feedback again.\n                                        <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n                                        <span aria-hidden=\"true\">\n                                          <i class=\"now-ui-icons ui-1_simple-remove\"></i>\n                                        </span>\n                                      </button>\n                                    </div>\n                                </div>\n                                <form id=\"feedbackFrom\" name=\"feedbackFrom\" style=\"width:80%;margin:auto;padding-top:30px;\" class=\"ng-pristine ng-valid\">\n                                    <h3 class=\"title text-center\">Submit Feedback</h3>\n                                    <p>Information you provide is used strictly for obtaining feedback that will improve our product, and is not used by or shared with any third party. For more information, please review our <a href=\"#\" ng-click=\"$ctrl.showModal(1)\">privacy policy</a>.\n                                    </p>\n                                    <div class=\"form-group\">\n                                        <!-- Full Name -->\n                                        <label for=\"full_name_id\" class=\"control-label\">Full Name</label>\n                                        <input type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"full_name_id\" name=\"full_name\" ng-model=\"$ctrl.feedback.inputName\" required>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <!-- Email  -->\n                                        <label for=\"email_id\" class=\"control-label\">Email Address</label>\n                                        <input type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"email_id\" name=\"full_name\" ng-model=\"$ctrl.feedback.inputEmail\" required>\n                                    </div>\n\n                                    <div class=\"form-group\">\n                                        <!-- Feebdack Type -->\n                                        <label for=\"type_id\" class=\"control-label\">Feedback Type</label>\n                                        <select class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"type_id\" ng-model=\"$ctrl.feedback.inputType\" required>\n                                          <option value=\"General Feedback\" selected=\"selected\">General Feedback</option>\n                                          <option value=\"Enhancement Request\">Enhancement Request</option>\n                                          <option value=\"Application Bug\">Application Bug</option>\n                                          <option value=\"Feature Request\">Feature Request</option>\n                \n                                        </select>\n                                    </div>\n                                    <!-- <div class=\"main-check\">\n                                        <div class=\"form-group\">\n                                            <div class=\"form-check\">\n                                                <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"termsCheck\" ng-model=\"$ctrl.feedback.check\">\n                                                <label class=\"form-check-label\" for=\"termsCheck\">\n                                                  Do you agree to our terms and conditions?\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div> -->\n                                    <div class=\"form-group\">\n                                        <!-- Comment Field -->\n                                        <label for=\"comment_id\" class=\"control-label\">Comments</label>\n                                        <textarea rows=\"3\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"comment_id\" name=\"comment\" placeholder=\"\" ng-model=\"$ctrl.feedback.inputComment\" required> </textarea>\n                                    </div>\n                                    <!-- ngIf: $ctrl.savingSpinner === false -->\n                                    <button class=\"btn btn-main ng-scope\" ng-click=\"$ctrl.submitFeedback(feedbackFrom)\" ng-if=\"$ctrl.savingSpinner === false\"> Submit Feedback</button>\n                                    <!-- end ngIf: $ctrl.savingSpinner === false -->\n                                    <!-- ngIf: $ctrl.savingSpinner === true -->\n\n\n                                </form>\n                            </div>\n                        </uib-tab-body>\n                    </uib-tab>\n\n                </uib-tabset>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-class=\"{fundingBackground : policysearchCtrl.modal.category === 'Funding Housing Affordability',stabilizingBackground : policysearchCtrl.modal.category === 'Stabilizing Neighborhoods',planningBackground : policysearchCtrl.modal.category === 'Planning for Production'}\">Close</button>\n                <!-- <button type=\"button\" class=\"btn btn-primary\">Save changes</button> -->\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(47);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	    /*@ngInject*/
	    MainController.$inject = ['$http', '$state', '$location', '$stateParams', 'searchService', '$anchorScroll', '$scope', '$rootScope'];
	    function MainController($http, $state, $location, $stateParams, searchService, $anchorScroll, $scope, $rootScope) {
	        _classCallCheck(this, MainController);
	
	        this.awesomeThings = [];
	        this.newThing = '';
	
	        this.$http = $http;
	        this.$state = $state;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.searchService = searchService;
	        this.$anchorScroll = $anchorScroll;
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	
	        this.$rootScope.canonicalUrl = this.$location.$$protocol + '://' + this.$location.$$host + this.$location.$$path;
	    }
	
	    _createClass(MainController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            console.log();
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            var key;
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                console.log(key);
	                this.$location.search('key', key);
	            }
	
	            if (this.$location.search().key) {
	                key = this.$location.search().key;
	                console.log(key);
	                this.searchService.setKey(key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log(_this.client);
	            });
	
	            this.$http.get(this.$scope.baseURL + '/api/tags/Recipes').then(function (response) {
	                console.log(response);
	                _this.recipeTags = response.data;
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.$http.get(this.$scope.baseURL + '/api/tags/Articles').then(function (response) {
	                console.log(response);
	                _this.articleTags = response.data;
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.$http.get(this.$scope.baseURL + '/api/tags/Initiatives').then(function (response) {
	                console.log(response);
	                _this.initiativeTags = response.data;
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.$http.get(this.$scope.baseURL + '/api/categories').then(function (response) {
	                console.log(response);
	                _this.collectionCategories = response.data;
	                _this.articleCategories = _.orderBy(_.filter(_this.collectionCategories, { 'collection': 'Articles' }), 'rank');
	                _this.initiativeCategories = _.orderBy(_.filter(_this.collectionCategories, { 'collection': 'Initiatives' }), 'rank');;
	                _this.recipeCategories = _.orderBy(_.filter(_this.collectionCategories, { 'collection': 'Recipes' }), 'rank');;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'loadResults',
	        value: function loadResults(category) {
	            var params;
	            console.log(this.searchParams);
	            if (category) {
	                params = {
	                    'category': category
	                };
	            } else if (this.searchParams && this.searchParams.uuid) {
	                params = {
	                    'q': this.searchParams.uuid
	                };
	            } else if (this.searchParams && !this.searchParams.uuid) {
	                console.log(this.searchParams);
	                params = {
	                    'q': this.searchParams
	                };
	            }
	
	            this.searchService.setSearchParams(params);
	            this.$stateParams = params;
	            this.$state.go('articles', params);
	        }
	    }, {
	        key: 'loadInitiatives',
	        value: function loadInitiatives(category) {
	            var params;
	            console.log(this.searchParamsInitiatives);
	
	            this.searchService.setSubCategory(null);
	            if (category) {
	                params = {
	                    'category': category
	                };
	            } else if (this.searchParamsInitiatives && this.searchParamsInitiatives.tag) {
	                params = {
	                    'q': this.searchParamsInitiatives.uuid
	                };
	            } else if (this.searchParamsInitiatives && !this.searchParamsInitiatives.tag) {
	                params = {
	                    'q': this.searchParamsInitiatives
	                };
	            }
	
	            this.searchService.setSearchParams(params);
	            this.$stateParams = params;
	            this.$state.go('initiatives', params);
	        }
	    }, {
	        key: 'loadRecipes',
	        value: function loadRecipes(category) {
	            var params;
	            console.log(this.searchParamsRecipes);
	
	            if (category) {
	                params = {
	                    'category': category
	                };
	            } else if (this.searchParamsRecipes && this.searchParamsRecipes.uuid) {
	                params = {
	                    'q': this.searchParamsRecipes.uuid
	                };
	            } else if (this.searchParamsRecipes && !this.searchParamsRecipes.uuid) {
	                params = {
	                    'q': this.searchParamsRecipes
	                };
	            }
	
	            this.searchService.setSearchParams(params);
	            this.$stateParams = params;
	            this.$state.go('recipes', params);
	        }
	    }, {
	        key: 'updateLocation',
	        value: function updateLocation(anchor) {
	            console.log(anchor);
	            this.$anchorScroll(anchor);
	            this.$location.hash(anchor);
	        }
	    }]);
	
	    return MainController;
	}();
	
	exports.default = _angular2.default.module('connectwellApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	    template: __webpack_require__(48),
	    controller: MainController
	}).name;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\" style=\"margin:auto;\">\n    <section class=\"resume-section p-3 p-lg-5 d-flex flex-column\" id=\"home\">\n        <div style=\"border-bottom:10px solid #FFCC00;\">\n            <div class=\"container\">\n                <img src=\"assets/images/Banner_books.png\" alt=\"\" width=\"100%\" height=\"auto\">\n            </div>\n        </div>\n\n        <div class=\"my-auto\">\n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <div class=\"container\">\n                <h2 class=\"text-center banner\" style=\"margin-bottom:15px;margin-top:15px;\">Your Wellness Connection</h2>\n                <div class=\"subheading text-center\" style=\"margin-top:0;\">Welcome to ConnectWell’s Health Information Website</div>\n                <div class=\"row\" style=\"margin:5%;\">\n                    <p>ConnectWell selectively curates health content from trusted sources to provide the latest standard of care guidelines and scientific findings on health, wellness, disease management, and nutrition.</p>\n\n                    <p>It&rsquo;s easy to browse for information on:</p>\n                    <ul>\n                        <li>Health, wellness, and disease topics from A to Z</li>\n                        <li>Wellness education and resources to help you adopt healthy lifestyle practices</li>\n                        <li>Healthy recipes that are tasty, easy, and made from fresh, healthy ingredients</li>\n                    </ul>\n                </div>\n                <div class=\"row text-center\" style=\"padding-top:20px;\">\n                    <div class=\"col-sm-4 searchBlock\" ng-click=\"$ctrl.updateLocation('articles')\">\n                        <img class=\"main-icons cursor-icon\" src=\"./assets/images/Health_and_Wellness_Library.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                        <br>\n                        <span class=\"init_title\">Health Information<br>Library</span>\n                    </div>\n                    <div class=\"col-sm-4 searchBlock\" ng-click=\"$ctrl.updateLocation('initiatives')\">\n                        <img class=\"main-icons cursor-icon\" src=\"./assets/images/Wellness_Initiatives.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                        <br>\n                        <span class=\"init_title\">Wellness<br>Initiatives</span>\n                    </div>\n                    <div class=\"col-sm-4 searchBlock\" ng-click=\"$ctrl.updateLocation('recipes')\">\n                        <img class=\"main-icons cursor-icon\" src=\"./assets/images/Healthy_Recipe_Collection.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                        <br>\n                        <span class=\"init_title\">Healthy Recipe<br>Collection</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </section>\n\n    <section class=\"resume-section p-3 p-lg-5 d-flex flex-column\" id=\"articles\" style=\"padding-top:0 !important;\">\n        <div class=\"my-auto\">\n            <div style=\"width:70%;margin:auto;border-top:10px solid #1c5494;\">\n                <div style=\"text-align:left;\">\n                    <img class=\"main-icons\" src=\"./assets/images/Health_and_Wellness_Library.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                    <div class=\"subheading mb-5\" style=\"margin-top:-90px;margin-left:130px;\">Health Information Library</div>\n                </div>\n            </div>\n\n            <div class=\"container\" style=\"width:100%;margin-top:70px;\">\n                <p>The library includes thousands of articles, hundreds of videos, and over one hundred programs covering health, wellness, and disease topics from A to Z. Each category includes a large collection of articles and videos providing breadth and depth so you can get the specific information to help you manage your health.</p>\n\n                <p>You can browse a category by clicking on an icon below or search using keywords. To use the search box, begin by typing your search term and select one of the keywords from the drop down menu.</p>\n\n\n                <div class=\"col-sm-12 col-md-8\" style=\"padding-left:0;\">\n                    <div class=\"form-group has-feedback\" style=\"height:100%;width:100%;\">\n                        <div class=\"input-group\" style=\"width:100%;height:50px;margin-top:10px;margin-bottom:10px;\">\n                            <input class=\"form-control border-right-0 border\" type=\"text\" id=\"example-search-input\" ng-model=\"$ctrl.searchParams\" placeholder=\"Search Keywords...\" uib-typeahead=\"tag as tag.tag for tag in $ctrl.articleTags | filter:$viewValue | limitTo:14\" typeahead-on-select=\"$ctrl.loadResults()\"\n                                aria-autocomplete=\"list\" aria-expanded=\"false\" aria-owns=\"typeahead-8-2486\">\n                            <span class=\"input-group-append\">\n                                <div class=\"input-group-text bg-transparent\"><i class=\"fa fa-search\"></i></div>\n                            </span>\n                        </div>\n                    </div>\n\n                </div>\n\n\n                <h4 class=\"mb-2\" style=\"padding-bottom:5px;margin-top:30px;\">Browse By Category\n                </h4>\n                <div class=\"row\" style=\"margin-left:0px;max-width:500px;\">\n                    <div class=\"col-xs-6 col-sm-4 col-md-3 text-center searchBlock\" ng-repeat=\"item in $ctrl.articleCategories\" ng-click=\"$ctrl.loadResults(item.uuid)\">\n                        <a href=\"#\">\n                            <img ng-src=\"{{item.iconUrl}}\" alt=\"\" width=\"100px\" height=\"100px\">\n                        </a>\n                        <br>\n                        <span class=\"init_title\">{{item.title}}</span>\n                    </div>\n                </div>\n\n\n\n            </div>\n\n\n        </div>\n    </section>\n\n\n\n    <section class=\"resume-section p-3 p-lg-5 d-flex flex-column\" id=\"initiatives\" style=\"padding-top:0px !important;\">\n        <div class=\"my-auto\" style=\"margin-top:0 !important;\">\n            <div style=\"width:70%;margin:auto;border-top:10px solid #f79330;\">\n                <div style=\"text-align:left;\">\n                    <img class=\"main-icons\" src=\"./assets/images/Wellness_Initiatives.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                    <div class=\"subheading mb-5\" style=\"margin-top:-90px;margin-left:130px;\">Wellness Initiatives</div>\n                </div>\n            </div>\n\n            <div class=\"container\" style=\"width:100%;margin-top:70px;\">\n                <p>Wellness Initiatives incorporate current, science-based practices and are designed to help people adopt habits that are fundamental to a healthy lifestyle. Each initiative includes a large collection of articles, videos, and tools designed to help you adopt healthy lifestyle practices in that specific area of well-being.</p>\n\n                <p>You can browse a category by clicking on an icon below or search using keywords. To use the search box, begin by typing your search term and select one of the keywords from the drop down menu.</p>\n                <div class=\"container\" style=\"padding-left:0;\">\n\n                    <div class=\"col-sm-12 col-md-8\" style=\"padding-left:0;\">\n                        <div class=\"form-group has-feedback\" style=\"height:100%;width:100%;\">\n                            <div class=\"input-group\" style=\"width:100%;height:50px;margin-top:10px;margin-bottom:10px;\">\n                                <input class=\"form-control border-right-0 border\" type=\"text\" id=\"example-search-input2\" ng-model=\"$ctrl.searchParamsInitiatives\" placeholder=\"Search Keywords...\" uib-typeahead=\"tag as tag.tag for tag in $ctrl.initiativeTags | filter:$viewValue | limitTo:14\"\n                                    typeahead-on-select=\"$ctrl.loadInitiatives()\" aria-autocomplete=\"list\" aria-expanded=\"false\" aria-owns=\"typeahead-8-2486\">\n                                <span class=\"input-group-append\">\n                                    <div class=\"input-group-text bg-transparent\"><i class=\"fa fa-search\"></i></div>\n                                </span>\n                            </div>\n                        </div>\n\n                    </div>\n\n\n                    <h4 class=\"mb-2\" style=\"margin-top:30px;padding-bottom:10px;\">Browse By Category\n                    </h4>\n                    <div class=\"row\" style=\"max-width: 500px;\">\n                        <div class=\"col-sm-2 col-md-4 searchBlock\" ng-repeat=\"item in $ctrl.initiativeCategories\" ng-click=\"$ctrl.loadInitiatives(item.uuid)\">\n                            <a href=\"#\">\n                                <img class=\"searchIcons\" ng-src=\"{{item.iconUrl}}\" alt=\"\">\n                            </a>\n                            <br>\n                            <span class=\"init_title\">{{item.description}}</span>\n                        </div>\n\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n    </section>\n\n    <section class=\"resume-section p-3 p-lg-5 d-flex flex-column\" id=\"recipes\" style=\"padding-top:0px !important;\">\n        <div class=\"my-auto\" style=\"margin-top:0 !important;\">\n            <div style=\"width:70%;margin:auto;border-top:10px solid #7ba740;\">\n                <div style=\"text-align:left;\">\n                    <img class=\"main-icons\" src=\"./assets/images/Healthy_Recipe_Collection.png\" alt=\"\" width=\"125px\" height=\"125px\">\n                    <div class=\"subheading mb-5\" style=\"margin-top:-90px;margin-left:130px;\">Healthy Recipe Collection</div>\n                </div>\n            </div>\n\n            <div class=\"container\" style=\"width:100%;margin-top:70px;;\">\n                <p>The Healthy Recipe Collection promotes better living through healthier eating. Each recipe educates on healthy eating, food-sourcing options, and highlights the hero ingredients. Recipes incorporate current nutrition science and are tasty, easy to make, and focus on using a variety of whole foods and healthy cooking methods.</p>\n\n                <p>You can browse a category by clicking on an icon below or search using keywords. To use the search box, begin by typing your search term and select one of the keywords from the drop-down menu.</p>\n                <div class=\"container\" style=\"padding-left:0;\">\n                    <div class=\"col-sm-12 col-md-8\" style=\"padding-left:0;\">\n                        <div class=\"input-group\" style=\"width:100%;height:50px;margin-top:10px;margin-bottom:10px;\">\n                            <input class=\"form-control py-2 border-right-0 border\" type=\"text\" id=\"example-search-input3\" ng-model=\"$ctrl.searchParamsRecipes\" placeholder=\"Search Keywords...\" uib-typeahead=\"tag as tag.tag for tag in $ctrl.recipeTags | filter:$viewValue | limitTo:8\"\n                                typeahead-on-select=\"$ctrl.loadRecipes()\" aria-autocomplete=\"list\" aria-expanded=\"false\" aria-owns=\"typeahead-8-2486\">\n                            <span class=\"input-group-append\">\n                                    <div class=\"input-group-text bg-transparent\"><i class=\"fa fa-search\"></i></div>\n                            </span>\n                        </div>\n                    </div>\n\n                    <h4 class=\"mb-2\" style=\"margin-top:30px;padding-bottom:10px;\">Browse By Category\n                    </h4>\n                    <div class=\"row\" style=\"max-width:500px;\">\n                        <div class=\"col-sm-3 col-md-3 searchBlock\" ng-repeat=\"item in $ctrl.recipeCategories\" ng-click=\"$ctrl.loadRecipes(item.uuid)\">\n                            <a href=\"#\">\n                                <img class=\"searchIcons\" ng-src=\"{{item.iconUrl}}\" alt=\"\">\n                            </a>\n                            <br>\n                            <span class=\"init_title\">{{item.title}}</span>\n                        </div>\n\n\n                    </div>\n\n\n                </div>\n\n            </div>\n        </div>\n    </section>\n\n</div>\n<footer></footer>"

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FeedbackComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _feedback = __webpack_require__(50);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var FeedbackComponent = exports.FeedbackComponent = function () {
	    /*@ngInject*/
	    FeedbackComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$stateParams', '$http'];
	    function FeedbackComponent($anchorScroll, searchService, $state, $window, $location, $stateParams, $http) {
	        _classCallCheck(this, FeedbackComponent);
	
	        this.message = 'Hello';
	        this.$http = $http;
	        this.$location = $location;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$stateParams = $stateParams;
	        this.feedback = {};
	        this.failed = false;
	        this.success = false;
	        this.savingSpinner = false;
	    }
	
	    _createClass(FeedbackComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var key;
	            this.$anchorScroll;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.article = this.searchService.getArticle();
	            console.log(this.article);
	
	            if (!this.$location.search().id && this.article) {
	                this.$location.search('id', this.article.uuid);
	            }
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(this.key);
	            }
	        }
	    }, {
	        key: 'submitFeedback',
	        value: function submitFeedback() {
	            var _this = this;
	
	            this.savingSpinner = true;
	            console.log(this.feedback);
	            this.$http.post(this.$scope.baseURL + '/api/users/feedback', this.feedback).then(function (response) {
	                _this.savingSpinner = false;
	                console.log(response);
	                _this.feedback = {};
	                _this.success = true;
	                _this.failed = false;
	                console.log(_this.savingSpinner);
	            }).catch(function (err) {
	                _this.savingSpinner = false;
	                console.log(err);
	                _this.success = false;
	                _this.failed = true;
	            });
	        }
	    }]);
	
	    return FeedbackComponent;
	}();
	
	exports.default = angular.module('webApp.feedback', [uiRouter]).config(_feedback2.default).component('feedback', {
	    template: __webpack_require__(51),
	    controller: FeedbackComponent,
	    controllerAs: 'feedbackCtrl'
	}).name;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('feedback', {
	    url: '/feedback',
	    template: '<feedback></feedback>'
	  });
	}];

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = "<section style=\"margin-top:150px;\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"alert alert-success\" role=\"alert\" ng-show=\"feedbackCtrl.success\">\n                    <div class=\"container\">\n                        <div class=\"alert-icon\">\n                            <i class=\"now-ui-icons ui-2_like\"></i>\n                        </div>\n                        <strong>Thank you!</strong> Your feedback has been submitted and will be reviewed as soon as possible.\n                        <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n                          <span aria-hidden=\"true\">\n                          <i class=\"now-ui-icons ui-1_simple-remove\"></i>\n                        </span>\n                      </button>\n                    </div>\n                </div>\n                <!-- Error alert -->\n                <div class=\"alert alert-danger\" role=\"alert\" ng-show=\"feedbackCtrl.failed\">\n                    <div class=\"container\">\n                        <div class=\"alert-icon\">\n                            <i class=\"now-ui-icons objects_support-17\"></i>\n                        </div>\n                        <strong>Oops!</strong> Something went wrong. Please try submitting your feedback again.\n                        <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n                        <span aria-hidden=\"true\">\n                          <i class=\"now-ui-icons ui-1_simple-remove\"></i>\n                        </span>\n                      </button>\n                    </div>\n                </div>\n                <form style=\"width:80%;margin:auto;\">\n                    <h2 class=\"title text-center\">Submit Feedback</h2>\n                    <div class=\"form-group\">\n                        <!-- Full Name -->\n                        <label for=\"full_name_id\" class=\"control-label\">Full Name</label>\n                        <input type=\"text\" class=\"form-control\" id=\"full_name_id\" name=\"full_name\" ng-model=\"feedbackCtrl.feedback.inputName\">\n                    </div>\n\n                    <div class=\"form-group\">\n                        <!-- Full Name -->\n                        <label for=\"email_id\" class=\"control-label\">Email Address</label>\n                        <input type=\"text\" class=\"form-control\" id=\"email_id\" name=\"full_name\" ng-model=\"feedbackCtrl.feedback.inputEmail\">\n                    </div>\n\n                    <div class=\"form-group\">\n                        <!-- State Button -->\n                        <label for=\"state_id\" class=\"control-label\">Feedback Type</label>\n                        <select class=\"form-control\" id=\"state_id\" ng-model=\"feedbackCtrl.feedback.inputType\">\n                          <option value=\"General Feedback\">General Feedback</option>\n                          <option value=\"Enhancement Request\">Enhancement Request</option>\n                          <option value=\"Application Bug\">Application Bug</option>\n                          <option value=\"Feature Request\">Feature Request</option>\n\n                        </select>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <!-- State Button -->\n                        <label for=\"state_id\" class=\"control-label\">Comments</label>\n                        <textarea rows=\"3\" class=\"form-control\" id=\"zip_id\" name=\"zip\" placeholder=\"\" ng-model=\"feedbackCtrl.feedback.inputComment\"> </textarea>\n                    </div>\n                    <button class=\"btn btn-main\" ng-click=\"feedbackCtrl.submitFeedback()\" ng-if=\"feedbackCtrl.savingSpinner === false\"> Submit Feedback</button>\n                    <button class=\"btn btn-main\" ng-click=\"feedbackCtrl.submitFeedback()\" ng-if=\"feedbackCtrl.savingSpinner === true\"><i class=\"fa fa-spinner fa-spin  fa-fw\"></i>  Saving</button>\n\n\n                </form>\n            </div>\n        </div>\n    </div>\n\n</section>\n\n<div class=\"container-fluid\" style=\"border-top: 1px solid #dee2e6;padding-top:10px;\">\n    <div class=\"row\" style=\"padding-left:20px;padding-right:20px;\">\n        <div class=\"col-lg-6 col-md-8 col-sm-8\" style=\"margin:auto;padding-top:5px;font-size:12px;\">\n            <p>\n                This information is not intended to provide advice on personal medical matters or to substitute for consultation with a physician. Translation of the English version of this information into other languages is done using machine translation. ConnectWell does not claim accuracy for the translation. Your use of this information means that you agree to the Terms of Use and Privacy Policy. To report any issues or problems with the site, let us know by using our Feedback Form. © 2024 ConnectWell – Integrating Wellness into Life®.\n            </p>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ArticlesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _articles = __webpack_require__(53);
	
	var _articles2 = _interopRequireDefault(_articles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ArticlesComponent = exports.ArticlesComponent = function () {
	    /*@ngInject*/
	    ArticlesComponent.$inject = ['$http', '$location', '$stateParams', 'searchService', '$state', '$anchorScroll', '$scope', '$sce'];
	    function ArticlesComponent($http, $location, $stateParams, searchService, $state, $anchorScroll, $scope, $sce) {
	        _classCallCheck(this, ArticlesComponent);
	
	        this.message = 'Hello';
	        this.$http = $http;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$sce = $sce;
	        this.hasKey = false;
	        this.$anchorScroll = $anchorScroll;
	        this.$scope = $scope;
	        this.filteredArticles = [];
	    }
	
	    _createClass(ArticlesComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$scope.baseURL = this.searchService.getBaseURL();
	
	            var params = this.searchService.getSearchParams();
	            console.log(params);
	            var key;
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (params.q && key) {
	                this.$location.url('?q=' + params.q + '&key=' + key);
	            } else if (params.category) {
	                this.$location.url("?category=" + params.category + '&key=' + key);
	            }
	
	            var searchParams = this.$location.search();
	            this.searchService.setKey(key);
	
	            this.key = key;
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log(_this.$scope.client);
	            });
	
	            if (_.isEmpty(searchParams)) {
	                this.$state.go('main');
	            }
	
	            if (!key) {
	                key = 0;
	            }
	            if (searchParams.q) {
	                this.$http.get(this.$scope.baseURL + '/api/articles/tag/' + searchParams.q + '/' + key).then(function (response) {
	                    console.log(response.data);
	                    _this.filteredArticles = response.data;
	                    _this.filteredArticles.forEach(function (element) {
	                        element.leadIn = _this.$sce.trustAsHtml(element.leadIn);
	                        element.title = _this.$sce.trustAsHtml(element.title);
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else if (searchParams.category) {
	                this.$http.get(this.$scope.baseURL + '/api/data/category/' + searchParams.category + '/' + key).then(function (response) {
	                    _this.newTags = [];
	                    console.log(response.data);
	                    _this.filteredArticles = response.data;
	                    _this.filteredArticles.forEach(function (element) {
	                        element.leadIn = _this.$sce.trustAsHtml(element.leadIn);
	                        element.title = _this.$sce.trustAsHtml(element.title);
	                    });
	                }).catch(function (err) {
	                    console.log(err);
	                    if (err.data === 'Forbidden') {
	                        _this.hasKey = false;
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'viewArticle',
	        value: function viewArticle(data) {
	            console.log(data);
	            this.searchService.setArticle(data);
	            this.searchService.setInitiative({});
	            this.$state.go('article');
	        }
	    }, {
	        key: 'viewVideo',
	        value: function viewVideo(data) {
	            console.log(data);
	            this.searchService.setArticle(data);
	            this.$state.go('articleVideo');
	        }
	    }, {
	        key: 'backToSearch',
	        value: function backToSearch(type) {
	            this.$location.url('/#' + type);
	            this.$anchorScroll(type);
	        }
	    }]);
	
	    return ArticlesComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.articles', [uiRouter]).config(_articles2.default).component('articles', {
	    template: __webpack_require__(54),
	    controller: ArticlesComponent,
	    controllerAs: 'articlesCtrl'
	}).name;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('articles', {
	    url: '/articles',
	    template: '<articles></articles>'
	  });
	}];

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <section class=\"resume-section p-3 p-lg-5 d-flex\">\n\n        <div class=\"col-sm-12 col-md-12\" style=\"padding:40px;max-width:1000px;margin:auto;\">\n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <div class=\"topnav\">\n                <a href=\"/\">Home</a>\n                <a href=\"/#articles\">Library</a>\n                <a class=\"active\" href=\"#\">Results</a>\n                <input type=\"text\" ng-model=\"searchArticles\" placeholder=\"Filter Results..\">\n\n            </div>\n\n            <div class=\"well list-container\" style=\"min-height:60vh\">\n                <div class=\"loading\" style=\"text-align:center;font-size: 12pt;\" ng-show=\"articlesCtrl.filteredArticles == 0\">\n                    <i class=\"fa fa-cog fa-spin\"></i> Loading...\n                </div>\n                <div class=\"list-group\">\n                    <span ng-show=\"articleList.length > 1\">Showing: {{articleList.length}} results</span>\n                    <span ng-show=\"articleList.length == 1\">Showing: {{articleList.length}} result</span>\n                    <!-- <div ng-show=\"articleList.length === 0\">\n                        <span style=\"padding-bottom:10px;\">Your search returned no results. Try searching again by selecting a category or selecting a key word.</span>\n                        <br><br>\n                        <button class=\"btn btn-main\" ng-click=\"articlesCtrl.backToSearch('articles')\">Search Again</button>\n                    </div> -->\n                    <span ng-show=\"!articlesCtrl.hasKey\">You are not authorized to view this content. To learn about obtaining an Access Key, please contact info@connectwell.health</span>\n                    <div class=\"row\" ng-repeat=\"article in  articleList = (articlesCtrl.filteredArticles | filter: searchArticles)\" style=\"padding:10px;border-bottom:1px solid lightgray;\">\n                        <div class=\"media col-sm-4\">\n                            <figure class=\"pull-left\">\n                                <img class=\"media-object img-rounded img-responsive\" ng-src=\"{{article.thumbnailUrl}}\" alt=\"placehold.it/350x250\" width=\"100%\" height=\"auto\">\n                                <!-- <img ng-src=\"https://s3-us-west-2.amazonaws.com/connectwell/assets/images/{{articleCtrl.article['File name']}}.png\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 15px 0px; border: 1px solid #000000;\"> -->\n                            </figure>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <h3 class=\"list-group-item-heading\" style=\"color:#2B558F;\" ng-click=\"articlesCtrl.viewArticle(article)\"> <span ng-bind-html = \"article.title\"></span> </h3>\n                            <span class=\"clearfix\" ng-bind-html = \"article.leadIn\">\n                            </span>\n\n                        </div>\n                        <div class=\"col-sm-2 text-center\">\n                            <!-- <h2> 14240 <small> votes </small></h2> -->\n                            <button ng-show=\"article.isVideo === 0\" type=\"button\" class=\"btn btn-main btn-lg btn-block\" ng-click=\"articlesCtrl.viewArticle(article)\"> View </button>\n                            <button ng-show=\"article.isVideo === 1 && client.hasVideo === 1\" type=\"button\" class=\"btn btn-warning btn-lg btn-block\" style=\"color:#2B558F;\" ng-click=\"articlesCtrl.viewArticle(article)\"> Watch <img src=\"assets/images/icons/UCTV_Play Button_50px.png\" width=\"25px\" height=\"25px\" alt=\"\" style=\"margin-bottom:3px;\"> </button>\n\n                        </div>\n                    </div>\n\n\n                </div>\n            </div>\n        </div>\n\n    </section>\n\n    <footer></footer>\n</div>"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ArticleComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _article = __webpack_require__(56);
	
	var _article2 = _interopRequireDefault(_article);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ArticleComponent = exports.ArticleComponent = function () {
	    /*@ngInject*/
	    ArticleComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$stateParams', '$http', '$scope', '$rootScope'];
	    function ArticleComponent($anchorScroll, searchService, $state, $window, $location, $stateParams, $http, $scope, $rootScope) {
	        _classCallCheck(this, ArticleComponent);
	
	        this.message = 'Hello';
	        this.$anchorScroll = $anchorScroll;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.$http = $http;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	    }
	
	    _createClass(ArticleComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	
	            this.$anchorScroll;
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.article = this.searchService.getArticle();
	            this.getCopyright('Standards of Care');
	
	            if (!this.$location.search().id && this.article) {
	                this.$location.search('id', this.article.uuid);
	            }
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(this.key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log(_this.$scope.client);
	
	                if (_this.$location.search().id) {
	                    _this.$http.get(_this.$scope.baseURL + '/api/articles/' + _this.$location.search().id + '/' + _this.key).then(function (response) {
	                        console.log("response data", response.data);
	
	                        _this.article = response.data[0];
	                        if (_this.article.updateDate) {
	                            _this.article.updateDate = moment(_this.article.updateDate).format('l');
	                        }
	                        if (_this.article.source === 'Mayo Clinic' && _this.article.originalUrl) {
	                            console.log(_this.$rootScope);
	                            _this.$rootScope.canonical = _this.article.originalUrl;
	                            console.log(_this.article.originalUrl);
	                            console.log(_this.$rootScope.canonical);
	                        }
	                        console.log(_this.article);
	                        if (_this.article.source === 'Mayo Clinic' || _this.article.source === 'Standards of Care') {
	                            $('.article-content').html(_this.article.html + '<br><br>Updated: ' + _this.article.updateDate);
	                            $('.subtitle-description').html("");
	                        } else if (_this.article.source === 'Mayo Video') {
	                            $('.video-content').html(_this.article.html);
	                            $('.video-description').html(_this.article.description);
	                            if (_this.article.updateDate) {
	                                $('.video-updateDate').html('Updated: ' + _this.article.updateDate);
	                            }
	                        } else if (_this.article.source === 'UCTV') {
	                            if (_this.$scope.client.uctvVideoType === 'youtube') {
	                                $('.video-content').html(_this.article.htmlYouTube);
	                                $('.video-description').html(_this.article.description);
	                                $('.subtitle-description').html(_this.article.subtitleDescription);
	                                if (_this.article.updateDate) {
	                                    $('.video-updateDate').html('Updated: ' + _this.article.updateDate);
	                                }
	                            } else {
	                                $('.video-content').html(_this.article.html);
	                                $('.video-description').html(_this.article.description);
	                                if (_this.article.updateDate) {
	                                    $('.video-updateDate').html('Updated: ' + _this.article.updateDate);
	                                }
	                                $('.subtitle-description').html("");
	                            }
	                        }
	
	                        $('.copyrightHtml').html(_this.article.copyright);
	                    }).catch(function (err) {
	                        console.log(err);
	                    });
	                } else {
	                    _this.$state.go('main');
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this2 = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this2.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('main');
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            this.$window.print();
	        }
	    }, {
	        key: 'backToResults',
	        value: function backToResults() {
	            this.$window.history.back();
	        }
	    }]);
	
	    return ArticleComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.article', [uiRouter]).config(_article2.default).component('article', {
	    template: __webpack_require__(57),
	    controller: ArticleComponent,
	    controllerAs: 'articleCtrl'
	}).name;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('article', {
	    url: '/article',
	    template: '<article></article>'
	  });
	}];

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <!-- ****** Single Blog Area Start ****** -->\n    <section class=\"resume-section p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;\">\n        <div class=\"container-fluid single_blog_area\">\n            <div class=\"row\" ng-show=\"client.hasArticlesMasthead === 1 && (client.hasMayoArticleMasthead == 1) && (articleCtrl.article.source === 'Mayo Clinic')\">\n                <div class=\"col-md-12 masthead\">\n                    <img src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/ConnectWell_Mayo+Masthead_August+2022_R4.png\" alt=\"\" width=\"100%\">\n                </div>\n            </div>\n            <div class=\"row\" ng-show=\"(client.hasArticlesMasthead === 1 && client.hasSOCMasthead == 1) && articleCtrl.article.source === 'Standards of Care'\">\n                <div class=\"col-md-12 masthead\">\n                    <img src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/ConnectWell_Standards+of+Care_July+2022_R2.png\" alt=\"\" width=\"100%\">\n                </div>\n            </div>\n            <div class=\"row\" ng-show=\"(client.hasVideoMasthead === 1 && client.hasUCTVMasthead == 1) && articleCtrl.article.source === 'UCTV'\">\n                <div class=\"col-md-12 masthead\">\n                    <img src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/UCTV-Horizontal-Clear-White-Background.jpg\" alt=\"\" width=\"100%\">\n                </div>\n            </div>\n            <div class=\"row\" ng-show=\"(client.hasVideoMasthead === 1 && client.hasMayoVideoMasthead == 1) && articleCtrl.article.source === 'Mayo Video'\">\n                <div class=\"col-md-12 masthead\">\n                    <img src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/ConnectWell_Mayo+Masthead_August+2022_R4.png\" alt=\"\" width=\"100%\">\n                </div>\n            </div>\n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <div class=\"row\">\n                <!-- Single Post -->\n                <div class=\"col-md-12\">\n                    <div class=\"text-right d-none d-sm-none d-md-block\" ng-show=\"client.hasMiniNavigation === 1\" style=\"padding-bottom:8px;\">\n                        <button class=\"btn btn-main\" ng-click=\"articleCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i> Home</button>\n                        <button class=\"btn btn-main\" ng-click=\"articleCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i> Back</button>\n                        <button class=\"btn btn-main\" ng-click=\"articleCtrl.print()\"><i class=\"fa fa-print\"></i> Print</button>\n                    </div>\n                    <div class=\"single-post\">\n\n                        <!-- Post Content -->\n                        <div class=\"post-content custom-lists article-styles\">\n                            <h1 style=\"text-align:left;padding-top:10px;\"><span ng-bind-html = \"articleCtrl.article.title\"></span></h1>\n\n\n\n                            <!-- START Article -->\n                            <div>\n                                <img ng-show=\"articleCtrl.article.isVideo === 0\" ng-src=\"{{articleCtrl.article.titleImageUrl}}\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 15px 0px; border: 1px solid #000000;\">\n                            </div>\n                            <div ng-show=\"articleCtrl.article.isVideo === 0\" class=\"article-content\" ></div>\n                            <div ng-show = \"articleCtrl.article.isVideo === 1\">\n                                <div class=\"row\">\n                                    <div class=\"video-content\"  style=\"height:55vh;width: 100%;margin-bottom:20px;margin-top:20px;\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"video-description\"></div>\n                                    <p class=\"subtitle-description\"></p>\n                                </div>\n                                <div class=\"row\">\n                                    <p class=\"video-updateDate\"></p>\n                                </div>\n                            </div>\n                            <!-- <div ng-show=\"articleCtrl.article.isVideo === 1\" class=\"article-content\" style=\"height:55vh;margin-bottom:20px;margin-top:20px;\"></div> -->\n                            <!-- Video Description  -->\n                            <!-- <div ng-show=\"articleCtrl.article.isVideo === 1\">\n                                <p class=\"video-description\"></p>\n                                <p class=\"subtitle-description\"></p>\n                            </div> -->\n\n                            <!-- ENDArticle -->\n\n                        </div>\n                       \n                    </div>\n\n                    <!-- Tags Area -->\n                    <div class=\"tags-area\" ng-if=\"articleCtrl.article.relatedArticle && client.hasEmbeddedArticles === 1\">\n                        <span class=\"servings\">Related Articles:</span>\n                        <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"article in articleCtrl.relatedArticles\">\n                            <a target=\"_self\" ng-href=\"/{{article.collection}}?id={{article.uuid}}&key={{articleCtrl.key}}\">{{article.articleTitle}}</a>\n                        </div>\n\n                    </div>\n                    <div class=\"tags-area\" style=\"padding-top:10px;\" ng-if=\"articleCtrl.article.relatedInitiative && client.hasEmbeddedInitiatives === 1\">\n                        <span class=\"servings\">Related Wellness Initiatives:</span>\n                        <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"initiative in articleCtrl.relatedInitiatives\">\n                            <a target=\"_self\" ng-href=\"/{{initiative.collection}}?id={{initiative.uuid}}&key={{articleCtrl.key}}\">{{initiative.articleTitle}}</a>\n                        </div>\n\n                    </div>\n                    <div class=\"tags-area\" style=\"padding-top:10px;\" ng-if=\"articleCtrl.article.relatedVideo && client.hasEmbeddedVideos === 1\">\n                        <span class=\"servings\">Related Videos:</span>\n                        <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"video in articleCtrl.relatedVideos\">\n                            <a target=\"_self\" ng-href=\"/articleVideo?id={{video.uuid}}&key={{articleCtrl.key}}\">{{video.videoTitle}}</a>\n                        </div>\n\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n\n\n    </section>\n    <!-- ****** Single Blog Area End ****** -->\n\n    <!-- Footer -->\n    <section class=\"p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;padding-bottom:5px !important;\">\n        <div class=\"container-fluid\">\n                <div class=\"single-post\">\n                    <div id=\"textbox\" style=\"display:flex; flex-flow:row wrap;font-size: 10pt;\">\n                        <p style=\"width:30%;text-align:left;\"> {{articleCtrl.article.attribution}}</p>\n                        <p class=\"copyrightHtml\" style=\"width:70%;text-align:right;\"></p>\n                    </div>\n                </div>\n            \n        </div>\n    </section>\n  \n\n\n    <footer></footer>\n</div>\n\n"

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ArticleVideoComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _articleVideo = __webpack_require__(59);
	
	var _articleVideo2 = _interopRequireDefault(_articleVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var ArticleVideoComponent = exports.ArticleVideoComponent = function () {
	    /*@ngInject*/
	    ArticleVideoComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$stateParams', '$http', '$scope'];
	    function ArticleVideoComponent($anchorScroll, searchService, $state, $window, $location, $stateParams, $http, $scope) {
	        _classCallCheck(this, ArticleVideoComponent);
	
	        this.message = 'Hello';
	        this.$anchorScroll = $anchorScroll;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.$http = $http;
	        this.$scope = $scope;
	    }
	
	    _createClass(ArticleVideoComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            this.$anchorScroll;
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.getCopyright('Standards of Care');
	
	            this.article = this.searchService.getArticle();
	            console.log(this.article);
	
	            if (!this.$location.search().id && this.article) {
	                this.$location.search('id', this.article.uuid);
	            }
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(this.key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data;
	                console.log(_this.$scope.client);
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            if (this.$location.search().id) {
	
	                this.$http.get(this.$scope.baseURL + '/api/articles/' + this.$location.search().id + '/' + this.key).then(function (response) {
	                    console.log("response data", response.data);
	
	                    _this.article = response.data;
	                    console.log(_this.article);
	                    $('.article-content').html(_this.article.videoSource);
	                    $('.video-description').html(_this.article.videoDescription);
	                    console.log("video: ", _this.relatedVideos);
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else {
	                this.$state.go('main');
	            }
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this2 = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this2.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('main');
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            this.$window.print();
	        }
	    }, {
	        key: 'backToResults',
	        value: function backToResults() {
	            this.$window.history.back();
	        }
	    }]);
	
	    return ArticleVideoComponent;
	}();
	
	exports.default = angular.module('webApp.articleVideo', [uiRouter]).config(_articleVideo2.default).component('articleVideo', {
	    template: __webpack_require__(60),
	    controller: ArticleVideoComponent,
	    controllerAs: 'articleVideoCtrl'
	}).name;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('articleVideo', {
	    url: '/articleVideo',
	    template: '<article-video></article-video>'
	  });
	}];

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n  <!-- ****** Single Blog Area Start ****** -->\n  <section class=\"resume-section p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;\">\n    <div class=\"container-fluid single_blog_area\">\n      <div class=\"row\">\n        <div class=\"col-md-12 masthead\" ng-show=\"client.videoMasthead === 1\">\n          <img\n            src=\"https://s3-us-west-2.amazonaws.com/connectwell.images/mastheads/UCTV-Horizontal-Clear-White-Background.jpg\"\n            alt=\"\" width=\"100%\">\n\n        </div>\n        <!-- Google Translate  -->\n        <div id=\"google_translate_element\"></div>\n        <script type=\"text/javascript\">\n          function googleTranslateElementInit() {\n\n            new google.translate.TranslateElement({\n              pageLanguage: 'en'\n            }, 'google_translate_element');\n\n          }\n\n        </script>\n        <!-- End Google Translate  -->\n      </div>\n      <div class=\"row\">\n        <!-- Single Post -->\n        <div class=\"col-md-12\">\n          <div class=\"text-right d-none d-sm-none d-md-block\" ng-show=\"client.miniNavigation === 1\">\n            <button class=\"btn btn-main\" ng-click=\"articleVideoCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i>\n              Home</button>\n            <button class=\"btn btn-main\" ng-click=\"articleVideoCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i>\n              Back</button>\n            <!-- <button class=\"btn btn-main\" ng-click=\"articleVideoCtrl.print()\"><i class=\"fa fa-print\"></i> Print</button> -->\n          </div>\n          <div class=\"single-post\">\n\n            <!-- Post Content -->\n            <div class=\"post-content custom-lists article-styles\">\n              <h1 style=\"text-align:left;margin-top:20px;margin-bottom:10px;\">{{articleVideoCtrl.article.videoTitle}}\n              </h1>\n\n              <!-- START Article -->\n              <div class=\"article-content\" style=\"height:55vh;margin-bottom:20px;margin-top:20px;\">\n              </div>\n              <div>\n                <p class=\"video-description\"></p>\n              </div>\n\n\n              <!-- ENDArticle -->\n\n            </div>\n          </div>\n\n          <!-- Tags Area -->\n          <div class=\"tags-area\" ng-if=\"articleVideoCtrl.article.relatedVideo && client.embeddedVideos === 1\">\n            <span class=\"servings\">Related Videos:</span>\n            <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"video in articleVideoCtrl.relatedVideos\">\n              <a target=\"_self\"\n                ng-href=\"/articleVideo?id={{video.uuid}}&key={{articleVideoCtrl.key}}\">{{video.videoTitle}}</a>\n            </div>\n\n          </div>\n\n          <div class=\"tags-area\" style=\"padding-top:10px;\"\n            ng-if=\"articleVideoCtrl.article.relatedArticle && client.embeddedArticles === 1\">\n            <span class=\"servings\">Related Articles:</span>\n            <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"article in articleVideoCtrl.relatedArticles\">\n              <a target=\"_self\"\n                ng-href=\"/{{article.collection}}?id={{article.uuid}}&key={{articleVideoCtrl.key}}\">{{article.articleTitle}}</a>\n            </div>\n\n          </div>\n          <div class=\"tags-area\" style=\"padding-top:10px;\"\n            ng-if=\"articleVideoCtrl.article.relatedInitiative && client.embeddedInitiatives === 1\">\n            <span class=\"servings \">Related Wellness Initiatives:</span>\n            <div class=\"col-md-4 \" style=\"padding-left:0; \"\n              ng-repeat=\"initiative in articleVideoCtrl.relatedInitiatives \">\n              <a target=\"_self\"\n                ng-href=\"/{{initiative.collection}}?id={{initiative.uuid}}&key={{articleVideoCtrl.key}} \">{{initiative.articleTitle}}</a>\n            </div>\n\n          </div>\n\n\n        </div>\n\n      </div>\n    </div>\n\n\n  </section>\n  <!-- ****** Single Blog Area End ****** -->\n\n  <!-- Footer -->\n  <div class=\"container-fluid \">\n    <div class=\"col-sm-12 text-right berkeley-footer \">\n      <div style=\"padding:5px;margin-right:5%; \">\n        {{copyrightUC}}\n      </div>\n    </div>\n  </div>\n\n  <footer></footer>\n</div>\n"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RecipesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _recipes = __webpack_require__(62);
	
	var _recipes2 = _interopRequireDefault(_recipes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var RecipesComponent = exports.RecipesComponent = function () {
	    /*@ngInject*/
	    RecipesComponent.$inject = ['$http', '$location', '$stateParams', 'searchService', '$state', '$scope'];
	    function RecipesComponent($http, $location, $stateParams, searchService, $state, $scope) {
	        _classCallCheck(this, RecipesComponent);
	
	        this.message = 'Hello';
	        this.$http = $http;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.hasKey = false;
	        this.$scope = $scope;
	        this.filteredRecipes = [];
	    }
	
	    _createClass(RecipesComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var params = this.searchService.getSearchParams();
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            console.log(params);
	            var key;
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (params.q && key) {
	                this.$location.url('?q=' + params.q + '&key=' + key);
	            } else if (params.category) {
	                this.$location.url("?category=" + params.category + '&key=' + key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log(_this.$scope.client);
	            });
	            var searchParams = this.$location.search();
	            this.searchService.setKey(key);
	
	            if (_.isEmpty(searchParams)) {
	                this.$state.go('main');
	            }
	
	            if (searchParams.q) {
	                this.$http.get(this.$scope.baseURL + '/api/recipes/tag/' + searchParams.q + '/' + key).then(function (response) {
	                    console.log(response.data);
	                    _this.filteredRecipes = response.data;
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else if (searchParams.category) {
	                    this.$http.get(this.$scope.baseURL + '/api/recipes/category/' + searchParams.category + '/' + key).then(function (response) {
	                        console.log(response.data);
	                        _this.filteredRecipes = response.data;
	                        console.log(JSON.parse(response.data[0].recipeTags));
	                    }).catch(function (err) {
	                        console.log(err);
	                        if (err.data === 'Forbidden') {
	                            _this.hasKey = false;
	                        }
	                    });
	                }
	        }
	    }, {
	        key: 'viewRecipe',
	        value: function viewRecipe(data) {
	            console.log(data);
	            this.searchService.setRecipe(data);
	
	            this.$state.go('recipe');
	        }
	    }, {
	        key: 'backToSearch',
	        value: function backToSearch(type) {
	            this.$location.url('/#' + type);
	            this.$anchorScroll(type);
	        }
	    }]);
	
	    return RecipesComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.recipes', [uiRouter]).config(_recipes2.default).component('recipes', {
	    template: __webpack_require__(63),
	    controller: RecipesComponent,
	    controllerAs: 'recipesCtrl'
	}).name;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('recipes', {
	    url: '/recipes',
	    template: '<recipes></recipes>'
	  });
	}];

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <section class=\"resume-section p-3 p-lg-5 d-flex\">\n        <div class=\"col-sm-12 col-md-12\" style=\"padding:40px;max-width:1000px;margin:auto;\">\n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <div class=\"topnav\">\n                <a href=\"/\">Home</a>\n                <a href=\"/#recipes\">Recipes</a>\n                <a class=\"active\" href=\"#\" style=\"background-color:#7ba740;\">Results</a>\n                <input type=\"text\" ng-model=\"searchRecipes\" placeholder=\"Filter Results..\">\n\n            </div>\n            <div class=\"well list-container\" style=\"min-height:60vh\">\n                <div class=\"loading\" style=\"text-align:center;font-size: 12pt;\" ng-show=\"recipesCtrl.filteredRecipes == 0\">\n                    <i class=\"fa fa-cog fa-spin\"></i> Loading...\n                </div>\n                <div class=\"list-group\">\n                    <span ng-show=\"recipeList.length > 1\">Showing: {{recipeList.length}} results</span>\n                    <span ng-show=\"recipeList.length == 1\">Showing: {{recipeList.length}} result</span>\n                    <span ng-show=\"!recipesCtrl.hasKey\">You are not authorized to view this content. To learn about obtaining an Access Key, please contact info@connectwell.health</span>\n                    <!-- <div ng-show=\"recipeList.length === 0\">\n                    <span style=\"padding-bottom:10px;\">Your search returned no results. Try searching again by selecting a category or selecting a key word.</span>\n                    <br><br>\n                    <button class=\"btn\" style=\"background-color:#7ba740; color:white;\" ng-click=\"recipesCtrl.backToSearch('recipes')\">Search Again</button>\n                </div> -->\n                    <div class=\"row\" ng-repeat=\"recipe in recipeList = (recipesCtrl.filteredRecipes | filter: searchRecipes)\" ng-click=\"recipesCtrl.viewRecipe(recipe)\" style=\"padding:10px;border-bottom:1px solid lightgray;\">\n                        <div class=\"media col-sm-4\">\n                            <figure class=\"pull-left\">\n\n                                <img class=\"media-object img-rounded img-responsive\" ng-src=\"{{recipe.thumbnailUrl}}\" alt=\"placehold.it/350x250\" width=\"100%\" height=\"auto\">\n                                <!-- <img ng-src=\"assets/images/{{articleCtrl.article['File name']}}.png\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 15px 0px; border: 1px solid #000000;\"> -->\n                            </figure>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <h3 class=\"list-group-item-heading\" style=\"color:#7ba740;\" ng-click=\"recipesCtrl.viewRecipe(recipe)\"> {{recipe.title}} </h3>\n                            <p class=\"clearfix\">{{recipe.leadIn}}\n                            </p>\n\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <!-- <h2> 14240 <small> votes </small></h2> -->\n                            <button type=\"button\" class=\"btn btn-default btn-lg btn-block\" style=\"background-color:#7ba740;color:white;\" ng-click=\"recipesCtrl.viewRecipe(recipe)\"> View </button>\n\n                        </div>\n                    </div>\n\n\n                </div>\n            </div>\n        </div>\n\n    </section>\n\n    <!-- <div class=\"container-fluid\" style=\"border-top: 1px solid #dee2e6;padding-top:10px;\">\n    <div class=\"row\" style=\"padding-left:20px;padding-right:20px;\">\n        <div class=\"col-lg-6 col-md-8 col-sm-8\" style=\"margin:auto;padding-top:5px;font-size:12px;\">\n            <p>\n                This information is not intended to provide advice on personal medical matters or to substitute for consultation with a physician. Your use of this information means that you agree to the <a style=\"font-size:10px;font-weight: normal\" href=\"https://www.connectwell.health/terms-of-use-1\">Terms of Use</a>                and <a href=\"https://www.connectwell.health/terms-of-use\" style=\"font-size:10px;\">Privacy Policy</a>. To report any issues or problems with the site, let us know by using our <a style=\"font-size:10px;font-weight: normal\" href=\"/feedback\">Feedback Form</a>.\n                © 2024 ConnectWell – Integrating Wellness into Life®.\n            </p>\n        </div>\n    </div>\n</div> -->\n    <footer></footer>"

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RecipeComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _recipe = __webpack_require__(65);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var RecipeComponent = exports.RecipeComponent = function () {
	    /*@ngInject*/
	    RecipeComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$stateParams', '$http', '$scope'];
	    function RecipeComponent($anchorScroll, searchService, $state, $window, $location, $stateParams, $http, $scope) {
	        _classCallCheck(this, RecipeComponent);
	
	        this.message = 'Hello';
	        this.$anchorScroll = $anchorScroll;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.$http = $http;
	        this.$scope = $scope;
	
	        this.$anchorScroll();
	    }
	
	    _createClass(RecipeComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$anchorScroll();
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.getCopyright('Standards of Care');
	
	            this.recipe = this.searchService.getRecipe();
	            var htmlCheck = this.recipe.hasOwnProperty('html');
	            if (!this.$location.search().id && this.recipe) {
	                this.$location.search('id', this.recipe.uuid);
	            }
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(this.key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	            });
	
	            if (this.$location.search().id) {
	
	                this.$http.get(this.$scope.baseURL + '/api/recipes/' + this.$location.search().id + '/' + this.key).then(function (response) {
	                    _this.recipe = response.data[0];
	                    console.log(_this.recipe);
	                    $('.recipe-content').html(_this.recipe.html);
	                    _this.loadEmbeddedRecipes(_this.$location.search().id);
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else if (this.recipe.uuid) {
	
	                this.$http.get(this.$scope.baseURL + '/api/recipes/' + this.recipe.uuid).then(function (response) {
	                    _this.recipe = response.data;
	                    console.log(_this.recipe);
	                    $('.recipe-content').html(_this.recipe.html);
	                    _this.loadEmbeddedRecipes(_this.recipe.uuid);
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else {
	                this.$state.go('main');
	            }
	
	            this.$anchorScroll();
	
	            if (htmlCheck) {
	                $('.recipe-content').html(this.recipe.html);
	            }
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this2 = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this2.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'loadEmbeddedRecipes',
	        value: function loadEmbeddedRecipes(uuid) {
	            var _this3 = this;
	
	            this.$http.get(this.$scope.baseURL + '/api/recipes/embedded/' + uuid + '/' + this.key).then(function (response) {
	                _this3.embeddedRecipes = response.data;
	                console.log(_this3.embeddedRecipes);
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            this.$window.print();
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('main');
	        }
	    }, {
	        key: 'backToResults',
	        value: function backToResults() {
	            this.$window.history.back();
	        }
	    }]);
	
	    return RecipeComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.recipe', [uiRouter]).config(_recipe2.default).component('recipe', {
	    template: __webpack_require__(66),
	    controller: RecipeComponent,
	    controllerAs: 'recipeCtrl'
	}).name;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('recipe', {
	    url: '/recipe',
	    template: '<recipe></recipe>'
	  });
	}];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <!-- ****** Single Blog Area Start ****** -->\n    <section class=\"resume-section p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;\">\n        <div class=\"container-fluid single_blog_area\">\n\n            <div class=\"row\" ng-show=\"client.hasRecipesMasthead === 1\">\n                <div class=\"col-md-12 masthead\">\n                    <img  src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/Wellness+Kitchen_Masthead_October_2020.png\" alt=\"\" width=\"100%\">\n                    <!-- Google Translate  -->\n                    <div id=\"google_translate_element\"></div>\n                    <script type=\"text/javascript\">\n                        function googleTranslateElementInit() {\n\n                            new google.translate.TranslateElement({\n                                pageLanguage: 'en'\n                            }, 'google_translate_element');\n\n                        }\n                    </script>\n                    <!-- End Google Translate  -->\n                </div>\n\n            </div>\n\n            <div class=\"row\" ng-show=\"client.hasRecipesCWMasthead === 1\">\n                <div class=\"col-md-12 masthead\">\n                    <img  src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/ConnectWell_Recipes+Masthead_July+2022_R2.png\" alt=\"\" width=\"100%\">\n                    <!-- Google Translate  -->\n                    <div id=\"google_translate_element\"></div>\n                    <script type=\"text/javascript\">\n                        function googleTranslateElementInit() {\n\n                            new google.translate.TranslateElement({\n                                pageLanguage: 'en'\n                            }, 'google_translate_element');\n\n                        }\n                    </script>\n                    <!-- End Google Translate  -->\n                </div>\n\n            </div>\n\n\n            <div class=\"row\" style=\"padding-top:30px;\">\n                <!-- Single Post -->\n                <div class=\"col-md-12\">\n\n                    <div class=\"text-right d-none d-sm-none d-md-block\" ng-show=\"client.hasMiniNavigation === 1\">\n                        <button class=\"btn btn-main\" ng-click=\"recipeCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i> Home</button>\n                        <button class=\"btn btn-main\" ng-click=\"recipeCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i> Back</button>\n                        <button class=\"btn btn-main\" ng-click=\"recipeCtrl.print()\"><i class=\"fa fa-print\"></i> Print</button>\n                    </div>\n                    <div class=\"single-post\" style=\"padding-top:10px;\">\n\n                        <!-- Post Content -->\n                        <div class=\"post-content custom-list recipe-styles\">\n\n                            <h1 style=\"text-align:left\">{{recipeCtrl.recipe.title}}</h1>\n\n                            <!-- START WORD DOC -->\n                            <img ng-src=\"{{recipeCtrl.recipe.titleImageUrl}}\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 15px 0px; border: 1px solid #000000;\">\n                            <div class=\"recipe-content\"></div>\n\n\n                            <!-- END WORD DOC -->\n\n                        </div>\n                    </div>\n\n                    <!-- Tags Area -->\n                    <div class=\"tags-area\" ng-if=\"client.hasEmbeddedRecipes == 1 && recipeCtrl.embeddedRecipes.length > 0\">\n                        <span class=\"servings\">Related Recipes:</span>\n                        <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"recipe in recipeCtrl.embeddedRecipes\">\n                            <a target=\"_self\" ng-href=\"/recipe?id={{recipe.uuid}}&key={{recipeCtrl.key}}\">{{recipe.title}}</a>\n                        </div>\n\n                    </div>\n\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </section>\n    <!-- ****** Single Blog Area End ****** -->\n</div>\n<!-- Footer -->\n<div class=\"container-fluid\">\n    <div class=\"col-sm-12 text-right berkeley-footer\">\n        <div style=\"padding:5px;margin-right:5%;font-size:10pt;\">\n            {{copyrightCW}}\n        </div>\n    </div>\n</div>\n\n<footer></footer>"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InitiativesComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _initiatives = __webpack_require__(68);
	
	var _initiatives2 = _interopRequireDefault(_initiatives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var InitiativesComponent = exports.InitiativesComponent = function () {
	    /*@ngInject*/
	    InitiativesComponent.$inject = ['$http', '$location', '$stateParams', 'searchService', '$state', '$scope'];
	    function InitiativesComponent($http, $location, $stateParams, searchService, $state, $scope) {
	        _classCallCheck(this, InitiativesComponent);
	
	        this.message = 'Hello';
	        this.$http = $http;
	        this.$location = $location;
	        this.$stateParams = $stateParams;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.maternalHealthSubCategory = false;
	        this.hasKey = false;
	        this.subcategory;
	        this.$scope = $scope;
	        this.filteredInitiatives = [];
	    }
	
	    _createClass(InitiativesComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var params = this.searchService.getSearchParams();
	            var subcategory = this.searchService.getSubCategory();
	            this.$scope.baseURL = this.searchService.getBaseURL();
	
	            console.log(params);
	            var key;
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (params.q && key) {
	                this.$location.url('?q=' + params.q + '&key=' + key);
	            } else if (params.category) {
	                this.$location.url("?category=" + params.category + '&key=' + key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log(_this.$scope.client);
	            });
	
	            var searchParams = this.$location.search();
	            this.searchService.setKey(key);
	
	            if (_.isEmpty(searchParams)) {
	                this.$state.go('main');
	            }
	
	            this.key = key;
	
	            if (searchParams.category) {
	                console.log(subcategory);
	                if (!subcategory) {
	                    subcategory = 'all';
	                    this.subcategory = subcategory;
	                }
	
	                if (searchParams.category === '2c51ca84-b6dc-11e9-a2a3-2a2ae2dbcce4') {
	                    this.maternalHealthSubCategory = true;
	                }
	                this.loadInitiatives(searchParams.category, subcategory);
	            } else if (searchParams.q) {
	                this.$http.get(this.$scope.baseURL + '/api/initiatives/tag/' + searchParams.q + '/' + key).then(function (response) {
	                    console.log(response.data);
	                    _this.filteredInitiatives = response.data;
	                }).catch(function (err) {
	                    console.log(err);
	                    if (err.data === 'Forbidden') {
	                        _this.hasKey = false;
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'loadInitiatives',
	        value: function loadInitiatives(category, subcategory) {
	            var _this2 = this;
	
	            console.log('clicked');
	            if (subcategory) {
	                this.searchService.setSubCategory(subcategory);
	                this.subcategory = subcategory;
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/initiatives/category/' + category + '/' + subcategory + '/' + this.key).then(function (response) {
	                console.log(response.data);
	                _this2.filteredInitiatives = response.data;
	            }).catch(function (err) {
	                console.log(err);
	                if (err.data === 'Forbidden') {
	                    _this2.hasKey = false;
	                }
	            });
	        }
	    }, {
	        key: 'viewInitiative',
	        value: function viewInitiative(data) {
	            console.log(data);
	            this.searchService.setInitiative(data);
	            this.searchService.setArticle({});
	            this.$state.go('initiative');
	        }
	    }, {
	        key: 'viewVideo',
	        value: function viewVideo(data) {
	            console.log(data);
	            this.searchService.setInitiative(data);
	            this.$state.go('initiativeVideo');
	        }
	    }, {
	        key: 'backToSearch',
	        value: function backToSearch(type) {
	            this.$location.url('/#' + type);
	            this.$anchorScroll(type);
	        }
	    }]);
	
	    return InitiativesComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.initiatives', [uiRouter]).config(_initiatives2.default).component('initiatives', {
	    template: __webpack_require__(69),
	    controller: InitiativesComponent,
	    controllerAs: 'initiativesCtrl'
	}).name;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('initiatives', {
	    url: '/initiatives',
	    template: '<initiatives></initiatives>'
	  });
	}];

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <section class=\"resume-section p-3 p-lg-5 d-flex\">\n\n        <div class=\"col-sm-12 col-md-12\" style=\"padding:40px;max-width:1000px;margin:auto;\">\n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <div class=\"topnav\">\n                <a href=\"/\">Home</a>\n                <a href=\"/#initiatives\">Initiatives</a>\n                <a class=\"active\" href=\"#\" style=\"background-color: #E6843C;\">Results</a>\n                <input type=\"text\" ng-model=\"searchInitiatives\" placeholder=\"Filter Results..\">\n\n            </div>\n            <div class=\"well list-container\"  style=\"min-height:60vh\">\n                <div class=\"loading\" style=\"text-align:center;font-size: 12pt;\" ng-show=\"initiativesCtrl.filteredInitiatives == 0\">\n                    <i class=\"fa fa-cog fa-spin\"></i> Loading...\n                </div>\n                <div class=\"row\" style=\"text-align: right;\" ng-show=\"initiativesCtrl.maternalHealthSubCategory\">\n\n                    <div class=\"col-sm-2 searchBlock\" ng-click=\"initiativesCtrl.loadInitiatives('2c51ca84-b6dc-11e9-a2a3-2a2ae2dbcce4','2e0668d0-718b-4d11-9ef3-021e6f5271d8')\">\n                        <a href=\"#\">\n                            <!-- <i class=\"fas fa-stethoscope fa-4x\" style=\"padding-top:10%;\"></i><br/> -->\n                            <img class=\"searchIcons\" src=\"assets/images/icons/CW_PFP_Icon.png\" alt=\"\">\n                        </a>\n                        <br>\n                        <span class=\"init_title\" ng-class=\"{'initiative-text': initiativesCtrl.subcategory === 'Preparing For Pregnancy' }\">Preparing<br>For Pregnancy</span>\n                    </div>\n                    <div class=\"col-sm-2 searchBlock\" ng-click=\"initiativesCtrl.loadInitiatives('2c51ca84-b6dc-11e9-a2a3-2a2ae2dbcce4','5c00f9f2-5bb4-4018-be83-f4d8971b70ba')\">\n                        <a href=\"#\">\n                            <img class=\"searchIcons\" src=\"assets/images/icons/CW_WDP_Icon.png\" alt=\"\">\n                        </a>\n                        <br>\n                        <span class=\"init_title\" ng-class=\"{'initiative-text': initiativesCtrl.subcategory === 'Wellness During Pregnancy' }\">Wellness<br>During Pregnancy</span>\n                    </div>\n                    <div class=\"col-sm-2 searchBlock\" ng-click=\"initiativesCtrl.loadInitiatives('2c51ca84-b6dc-11e9-a2a3-2a2ae2dbcce4','dd456b33-22b8-4f68-8c6b-7ff00f72f390')\">\n                        <a href=\"#\">\n                            <img class=\"searchIcons\" src=\"assets/images/icons/CW_TPP_Icon.png\" alt=\"\">\n                        </a>\n                        <br>\n                        <span class=\"init_title\">Thrive<br>Postpartum</span>\n                    </div>\n\n\n                </div>\n\n                <!-- <h1 class=\"text-center\">Vote for your favorite</h1> -->\n                <div class=\"list-group\" style=\"padding-top:10px;\">\n                    <span ng-show=\"initiativeList.length > 1\">Showing: {{initiativeList.length}} results</span>\n                    <span ng-show=\"initiativeList.length == 1\">Showing: {{initiativeList.length}} result</span>\n                    <span ng-show=\"!initiativesCtrl.hasKey\">You are not authorized to view this content. To learn about obtaining an Access Key, please contact info@connectwell.health</span>\n                    <!-- <div ng-show=\"initiativeList.length === 0\">\n                    <span style=\"padding-bottom:10px;\">Your search returned no results. Clear any filters or try searching again by selecting a category or a key word.</span>\n                    <br><br>\n                    <button class=\"btn\" style=\"background-color: #E6843C;color:white;\" ng-click=\"initiativesCtrl.backToSearch('initiatives')\">Search Again</button>\n                </div> -->\n                    <div class=\"row\" ng-repeat=\"initiative in initiativeList = (initiativesCtrl.filteredInitiatives | filter:searchInitiatives)\" ng-click=\"initiativesCtrl.viewinitiative(initiative)\" style=\"padding:10px;border-bottom:1px solid lightgray;\">\n                        <div class=\"media col-sm-4\">\n                            <figure class=\"pull-left\">\n\n                                <img class=\"media-object img-rounded img-responsive\" ng-src=\"{{initiative.thumbnailUrl}}\" alt=\"placehold.it/350x250\" width=\"100%\" height=\"auto\">\n                                <!-- <img ng-src=\"assets/images/{{articleCtrl.article['File name']}}.png\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 15px 0px; border: 1px solid #000000;\"> -->\n                            </figure>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <h3 class=\"list-group-item-heading\" style=\"color:#E6843C;\" ng-click=\"initiativesCtrl.viewInitiative(initiative)\"> {{initiative.title}} <span ng-show=\"initiative.initiativeTitle === 'Sign Up for TSA Pre'\" class=\"tsa-pre-check-mark\">✓</span> </h3>\n                            <p class=\"clearfix\">{{initiative.leadIn}}\n                            </p>\n\n                        </div>\n                        <div class=\"col-sm-2 text-center\">\n                            <!-- <h2> 14240 <small> votes </small></h2> -->\n                            <button ng-show=\"initiative.isVideo === 0\" type=\"button\" class=\"btn btn-default btn-lg btn-block\" style=\"background-color:#E6843C;color:white;\" ng-click=\"initiativesCtrl.viewInitiative(initiative)\"> View </button>\n                            <button ng-show=\"initiative.isVideo === 1 && client.hasVideo === 1\" type=\"button\" class=\"btn btn-warning btn-lg btn-block\" style=\"color:#2B558F;\" ng-click=\"initiativesCtrl.viewVideo(initiative)\"> Watch <img src=\"assets/images/icons/UCTV_Play Button_50px.png\" width=\"25px\" height=\"25px\" alt=\"\" style=\"margin-bottom:3px;\"> </button>\n\n                        </div>\n                    </div>\n\n\n                </div>\n            </div>\n        </div>\n\n    </section>\n\n    <!-- <div class=\"container-fluid\" style=\"border-top: 1px solid #dee2e6;padding-top:10px;\">\n    <div class=\"row\" style=\"padding-left:20px;padding-right:20px;\">\n        <div class=\"col-lg-6 col-md-8 col-sm-8\" style=\"margin:auto;padding-top:5px;font-size:12px;\">\n            <p>\n               This information is not intended to provide advice on personal medical matters or to substitute for consultation with a physician. Translation of the English version of this information into other languages is done using machine translation. ConnectWell does not claim accuracy for the translation. Your use of this information means that you agree to the Terms of Use and Privacy Policy. To report any issues or problems with the site, let us know by using our Feedback Form. © 2024 ConnectWell – Integrating Wellness into Life®.\n            </p>\n        </div>\n    </div>\n</div> -->\n    <footer></footer>"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InitiativeComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _initiative = __webpack_require__(71);
	
	var _initiative2 = _interopRequireDefault(_initiative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var InitiativeComponent = exports.InitiativeComponent = function () {
	    /*@ngInject*/
	    InitiativeComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$http', '$scope'];
	    function InitiativeComponent($anchorScroll, searchService, $state, $window, $location, $http, $scope) {
	        _classCallCheck(this, InitiativeComponent);
	
	        this.message = 'Hello';
	        this.$anchorScroll = $anchorScroll;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	        this.$http = $http;
	        this.$scope = $scope;
	    }
	
	    _createClass(InitiativeComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$anchorScroll;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.getCopyright('Standards of Care');
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(this.key);
	            }
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log("the client is: ", _this.$scope.client);
	            });
	
	            this.initiative = this.searchService.getInitiative();
	
	            if (!this.$location.search().id && this.initiative) {
	                console.log('adding location id', this.initiative.uuid);
	                this.$location.search('id', this.initiative.uuid);
	            }
	
	            if (this.$location.search().id) {
	
	                this.$http.get(this.$scope.baseURL + '/api/initiatives/' + this.$location.search().id + '/' + this.key).then(function (response) {
	                    console.log(response.data);
	                    _this.initiative = response.data[0];
	                    if (_this.initiative.updateDate) {
	                        _this.initiative.updateDate = moment(_this.initiative.updateDate).format('l');
	                    }
	                    $('.initiative-content').html(_this.initiative.html + '<br><br>Updated: ' + _this.initiative.updateDate);
	                    console.log(_this.initiative.html);
	                    console.log(_this.initiative);
	                    _this.getRelatedInitiatives(_this.initiative);
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else {}
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this2 = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this2.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            this.$window.print();
	        }
	    }, {
	        key: 'backToResults',
	        value: function backToResults() {
	            this.$window.history.back();
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('main');
	        }
	    }, {
	        key: 'getRelatedInitiatives',
	        value: function getRelatedInitiatives(data) {
	            var _this3 = this;
	
	            this.$http.get(this.$scope.baseURL + '/api/initiatives/related/' + data.uuid + '/' + this.key).then(function (response) {
	                console.log(response.data);
	                _this3.relatedInitiatives = response.data;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'loadRelatedInitiative',
	        value: function loadRelatedInitiative(data) {
	            var _this4 = this;
	
	            this.$anchorScroll();
	            console.log(data);
	            this.$http.get(this.$scope.baseURL + '/api/initiatives/' + data.uuid + '/' + this.key).then(function (response) {
	                console.log(response.data);
	                _this4.initiative = response.data;
	                $('.initiative-content').html(_this4.initiative.html);
	                console.log(_this4.initiative);
	                console.log(JSON.parse(_this4.initiative.initiativeTags));
	                if (_this4.initiative.relatedInitiative) {
	                    console.log(JSON.parse(_this4.initiative.relatedInitiative));
	                    _this4.relatedInitiatives = JSON.parse(_this4.initiative.relatedInitiative);
	                }
	                if (_this4.initiative.relatedVideo) {
	                    console.log(JSON.parse(_this4.initiative.relatedInitiative));
	                    _this4.relatedVideos = JSON.parse(_this4.initiative.relatedVideo);
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }]);
	
	    return InitiativeComponent;
	}();
	
	exports.default = angular.module('connectwellTemplateApp.initiative', [uiRouter]).config(_initiative2.default).component('initiative', {
	    template: __webpack_require__(72),
	    controller: InitiativeComponent,
	    controllerAs: 'initiativeCtrl'
	}).name;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('initiative', {
	    url: '/initiative',
	    template: '<initiative></initiative>'
	  });
	}];

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n    <!-- ****** Single Blog Area Start ****** -->\n    <section class=\"resume-section p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;\">\n        <div class=\"container-fluid single_blog_area\">\n            <div class=\"row\" ng-show=\"client.hasInitiativesMasthead === 1\">\n                <div class=\"col-md-12 masthead\" style=\"padding-top:10px;\">\n                    <img src=\"https://s3.us-west-2.amazonaws.com/connectwell.images/mastheads/ConnectWell_Wellness_Initiative_Masthead.png\" alt=\"\" width=\"100%\">\n                </div>\n            </div>\n            \n            <!-- Google Translate  -->\n            <div id=\"google_translate_element\"></div>\n            <script type=\"text/javascript\">\n                function googleTranslateElementInit() {\n\n                    new google.translate.TranslateElement({\n                        pageLanguage: 'en'\n                    }, 'google_translate_element');\n\n                }\n            </script>\n            <!-- End Google Translate  -->\n            <!-- Single Post -->\n\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"text-right d-none d-sm-none d-md-block\" ng-show=\"client.hasMiniNavigation === 1\">\n                        <div class=\"text-right d-md-none d-lg-none d-xl-none\" style=\"padding-top:10px;\">\n                            <button class=\"btn btn-main\" ng-click=\"initiativeCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i> Home</button>\n                            <button class=\"btn btn-main\" ng-click=\"initiativeCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i> Back</button>\n                        </div>\n                        <div class=\"text-right d-none d-sm-none d-md-block\">\n                            <button class=\"btn btn-main\" ng-click=\"initiativeCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i> Home</button>\n                            <button class=\"btn btn-main\" ng-click=\"initiativeCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i> Back</button>\n                            <button class=\"btn btn-main\" ng-click=\"initiativeCtrl.print()\"><i class=\"fa fa-print\"></i> Print</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"single-post\" style=\"padding-top:30px;\">\n\n                <!-- Post Content -->\n                <div class=\"post-content custom-lists initiative-styles\">\n                    <div class=\"initiative-title\" style=\"text-align:left;padding-bottom:10px;\">{{initiativeCtrl.initiative.title}}<span ng-show=\"initiativeCtrl.initiative.title === 'Sign Up for TSA Pre'\" class=\"tsa-pre-check-mark\"><strong>&radic;</strong> ®</span></div>\n\n\n\n\n                    <!-- START WORD DOC -->\n                    <img ng-src=\"{{initiativeCtrl.initiative.titleImageUrl}}\" height=\"auto\" width=\"100%\" alt=\"Image\" style=\"float: left; margin: 4px 30px 40px 0px; border: 1px solid #000000;\">\n                    <div class=\"initiative-content\"></div>\n\n\n                    <!-- END WORD DOC -->\n\n                </div>\n            </div>\n\n            <!-- Tags Area -->\n\n            <div class=\"tags-area\" ng-if=\"initiativeCtrl.relatedInitiatives.length > 0\" style=\"padding-top:10px;\" ng-show=\"initiativeCtrl.relatedInitiatives && client.hasEmbeddedInitiatives === 1\">\n                <span class=\"servings\">Related Wellness Initiatives:</span>\n                <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"initiative in initiativeCtrl.relatedInitiatives\">\n                    <a target=\"_self\" ng-href=\"/initiative?id={{initiative.uuid}}&key={{initiativeCtrl.key}} \">{{initiative.title}}</a>\n                </div>\n\n            </div>\n\n            <div class=\"tags-area\" style=\"padding-top:10px;\" ng-if=\"initiativeCtrl.initiative.relatedVideo && hasVideo === 1\">\n                <span class=\"servings\">Related Videos:</span>\n                <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"video in initiativeCtrl.relatedVideos\">\n                    <a target=\"_self\" ng-href=\"/initiativeVideo?id={{video.uuid}}&key={{initiativeCtrl.key}}\">{{video.videoTitle}}</a>\n                </div>\n\n            </div>\n\n            <div class=\"row footer-tagline\">\n                <div class=\"col-sm-6 caption\"></div>\n                <div class=\"col-sm-6 text-right\" style=\"font-size:10pt;\">\n                    {{copyrightCW}}\n                </div>\n\n            </div>\n\n        </div>\n\n    </section>\n\n    <!-- ****** Single Blog Area End ****** -->\n\n    <footer></footer>"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InitiativeVideoComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _initiativeVideo = __webpack_require__(74);
	
	var _initiativeVideo2 = _interopRequireDefault(_initiativeVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(9);
	
	var InitiativeVideoComponent = exports.InitiativeVideoComponent = function () {
	    /*@ngInject*/
	    InitiativeVideoComponent.$inject = ['$anchorScroll', 'searchService', '$state', '$window', '$location', '$http', '$scope'];
	    function InitiativeVideoComponent($anchorScroll, searchService, $state, $window, $location, $http, $scope) {
	        _classCallCheck(this, InitiativeVideoComponent);
	
	        this.message = 'Hello';
	        this.$anchorScroll = $anchorScroll;
	        this.searchService = searchService;
	        this.$state = $state;
	        this.$window = $window;
	        this.$location = $location;
	        this.$http = $http;
	        this.$scope = $scope;
	        this.message = 'Hello';
	    }
	
	    _createClass(InitiativeVideoComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var key;
	            this.$anchorScroll;
	            this.$scope.baseURL = this.searchService.getBaseURL();
	            document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	            this.getCopyright('UCTV');
	
	            if (this.searchService.getKey()) {
	                key = this.searchService.getKey();
	                this.hasKey = true;
	                this.key = key;
	            } else if (this.$location.search().key) {
	                key = this.$location.search().key;
	                this.key = key;
	                this.hasKey = true;
	            } else {
	                this.hasKey = false;
	            }
	
	            if (!this.$location.search().key) {
	                console.log(key);
	
	                this.$location.search('key', key);
	            }
	
	            if (!this.searchService.getKey()) {
	                this.searchService.setKey(key);
	            }
	
	            console.log(key);
	
	            this.$http.get(this.$scope.baseURL + '/api/cw/client/' + key).then(function (response) {
	                _this.$scope.client = response.data[0];
	                console.log("the client is: ", _this.$scope.client);
	                _this.getInitiative();
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'getInitiative',
	        value: function getInitiative() {
	            var _this2 = this;
	
	            this.initiative = this.searchService.getInitiative();
	
	            console.log(this.initiative);
	            console.log(this.$location.search());
	            if (!this.$location.search().id && this.initiative.uuid) {
	                console.log('adding location id', this.initiative.uuid);
	                this.$location.search('id', this.initiative.uuid).replace();
	            }
	
	            if (this.$location.search().id) {
	                this.$http.get(this.$scope.baseURL + '/api/initiatives/' + this.$location.search().id + '/' + this.key).then(function (response) {
	                    _this2.initiative = response.data[0];
	
	                    console.log(_this2.initiative);
	
	                    if (_this2.$scope.client.uctvVideoType === 'youtube') {
	                        $('.video-content').html(_this2.initiative.htmlYouTube);
	                        $('.video-description').html(_this2.initiative.description);
	                        $('.subtitle-description').html(_this2.initiative.subtitleDescription);
	                        if (_this2.initiative.updateDate) {
	                            $('.video-updateDate').html('Updated: ' + _this2.initiative.updateDate);
	                        }
	                    } else {
	                        $('.video-content').html(_this2.initiative.html);
	                        $('.video-description').html(_this2.initiative.description);
	                        if (_this2.initiative.updateDate) {
	                            $('.video-updateDate').html('Updated: ' + _this2.initiative.updateDate);
	                        }
	                        $('.subtitle-description').html("");
	                    }
	
	                    if (_this2.initiative.relatedInitiative) {
	                        console.log(JSON.parse(_this2.initiative.relatedInitiative));
	                        _this2.relatedInitiatives = JSON.parse(_this2.initiative.relatedInitiative);
	                        console.log("related initiaitives: ", _this2.relatedInitiatives);
	                    }
	
	                    if (_this2.initiative.relatedVideo) {
	                        console.log(JSON.parse(_this2.initiative.relatedInitiative));
	                        _this2.relatedVideos = JSON.parse(_this2.initiative.relatedVideo);
	                    }
	
	                    if (_this2.initiative.relatedArticle) {
	                        _this2.relatedArticles = JSON.parse(_this2.initiative.relatedArticle);
	                    }
	                }).catch(function (err) {
	                    console.log(err);
	                });
	            } else {}
	        }
	    }, {
	        key: 'getCopyright',
	        value: function getCopyright(type) {
	            var _this3 = this;
	
	            var key;
	            this.$http.get(this.$scope.baseURL + '/api/data/copyright/' + type).then(function (response) {
	                _this3.$scope.copyrightCW = response.data[0].copyright;
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            this.$window.print();
	        }
	    }, {
	        key: 'backToResults',
	        value: function backToResults() {
	            this.$window.history.back(-2);
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('main');
	        }
	    }, {
	        key: 'loadRelatedInitiative',
	        value: function loadRelatedInitiative(data) {
	            var _this4 = this;
	
	            this.$anchorScroll();
	            console.log(data);
	            this.$http.get(this.$scope.baseURL + '/api/initiatives/' + data.uuid + '/' + this.key).then(function (response) {
	                console.log(response.data);
	                _this4.initiative = response.data;
	                $('.initiative-content').html(_this4.initiative.html);
	                console.log(_this4.initiative);
	                console.log(JSON.parse(_this4.initiative.initiativeTags));
	                if (_this4.initiative.relatedInitiative) {
	                    console.log(JSON.parse(_this4.initiative.relatedInitiative));
	                    _this4.relatedInitiatives = JSON.parse(_this4.initiative.relatedInitiative);
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }]);
	
	    return InitiativeVideoComponent;
	}();
	
	exports.default = angular.module('webApp.initiativeVideo', [uiRouter]).config(_initiativeVideo2.default).component('initiativeVideo', {
	    template: __webpack_require__(75),
	    controller: InitiativeVideoComponent,
	    controllerAs: 'initiativeVideoCtrl'
	}).name;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('initiativeVideo', {
	    url: '/initiativeVideo',
	    template: '<initiative-video></initiative-video>'
	  });
	}];

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid p-0\">\n  <!-- ****** Single Blog Area Start ****** -->\n  <section class=\"resume-section p-3 p-lg-5 d-flex d-column\" style=\"margin:auto;max-width:1000px;border-bottom:0px;\">\n    <div class=\"container-fluid single_blog_area\">\n      <div class=\"row\" >\n        <div class=\"col-md-12 masthead\" ng-show=\"client.hasVideoMasthead === 1\">\n          <img\n            src=\"https://s3-us-west-2.amazonaws.com/connectwell.images/mastheads/UCTV-Horizontal-Clear-White-Background.jpg\"\n            alt=\"\" width=\"100%\">\n\n        </div>\n         <!-- Google Translate  -->\n <div id=\"google_translate_element\"></div>\n <script type=\"text/javascript\">\n   function googleTranslateElementInit() {\n\n     new google.translate.TranslateElement({\n       pageLanguage: 'en'\n     }, 'google_translate_element');\n\n   }\n\n </script>\n <!-- End Google Translate  -->\n      </div>\n      <div class=\"row\">\n        <!-- Single Post -->\n        <div class=\"col-md-12\">\n          <div class=\"text-right d-none d-sm-none d-md-block\" ng-show=\"client.hasMiniNavigation === 1\">\n            <button class=\"btn btn-main\" ng-click=\"initiativeVideoCtrl.goHome()\"><i class=\"fa fa-arrow-left\"></i>\n              Home</button>\n            <button class=\"btn btn-main\" ng-click=\"initiativeVideoCtrl.backToResults()\"><i class=\"fa fa-arrow-left\"></i>\n              Back</button>\n            <!-- <button class=\"btn btn-main\" ng-click=\"initiativeVideoCtrl.print()\"><i class=\"fa fa-print\"></i> Print</button> -->\n          </div>\n          <div class=\"single-post\">\n           \n            <!-- Post Content -->\n            <div class=\"post-content custom-lists article-styles\">\n              <h1 style=\"text-align:left;margin-top:20px;margin-bottom:10px;\">\n                {{initiativeVideoCtrl.initiative.title}}</h1>\n\n              <!-- START Article -->\n             \n              <div>\n                <div class=\"row\">\n                  <div class=\"video-content\"  style=\"height:55vh;width: 100%;margin-bottom:20px;margin-top:20px;\"></div>\n              </div>\n              <div class=\"row\">\n                  <div class=\"video-description\"></div>\n                  <p class=\"subtitle-description\"></p>\n              </div>\n              <div class=\"row\">\n                  <p class=\"video-updateDate\"></p>\n              </div>\n              </div>\n\n\n              <!-- ENDArticle -->\n\n            </div>\n          </div>\n\n          <!-- Tags Area -->\n          <div class=\"tags-area\" ng-if=\"initiativeVideoCtrl.initiative.relatedVideo && client.hasVideo === 1\">\n            <span class=\"servings\">Related Videos:</span>\n            <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"video in initiativeVideoCtrl.relatedVideos\">\n              <a target=\"_self\"\n                ng-href=\"/initiativeVideo?id={{video.uuid}}&key={{initiativeVideoCtrl.key}}\">{{video.videoTitle}}</a>\n            </div>\n\n          </div>\n\n          <div class=\"tags-area\" style=\"padding-top:10px;\"\n            ng-if=\"initiativeVideoCtrl.initiative.relatedArticle && hasEmbeddedArticles === 1\">\n            <span class=\"servings\">Related Articles:</span>\n            <div class=\"col-md-4\" style=\"padding-left:0;\" ng-repeat=\"article in initiativeVideoCtrl.relatedArticles\">\n              <a target=\"_self\"\n                ng-href=\"/{{initiative.collection}}?id={{initiative.uuid}}&key={{initiativeVideoCtrl.key}}\">{{initiative.articleTitle}}</a>\n            </div>\n\n          </div>\n          <div class=\"tags-area\" style=\"padding-top:10px;\"\n            ng-if=\"initiativeVideoCtrl.initiative.relatedInitiative && hasEmbeddedInitiatives === 1\">\n            <span class=\"servings \">Related Wellness Initiatives:</span>\n            <div class=\"col-md-4 \" style=\"padding-left:0; \"\n              ng-repeat=\"initiative in initiativeVideoCtrl.relatedInitiatives \">\n              <a target=\"_self\"\n                ng-href=\"/{{initiative.collection}}?id={{initiative.uuid}}&key={{initiativeVideoCtrl.key}} \">{{initiative.initiativeTitle}}</a>\n            </div>\n\n          </div>\n\n\n        </div>\n\n      </div>\n    </div>\n\n\n  </section>\n  <!-- ****** Single Blog Area End ****** -->\n\n  <!-- Footer -->\n  <div class=\"container-fluid \">\n    <div class=\"col-sm-12 text-right berkeley-footer \">\n      <div style=\"padding:5px;margin-right:5%; font-size: 10pt;\">\n        {{copyrightCW}}\n      </div>\n    </div>\n  </div>\n\n  <footer></footer>\n</div>\n"

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.searchServiceService = searchServiceService;
	var angular = __webpack_require__(1);
	var baseURL = 'https://api.connectwellengage.health/dev';
	
	/*@ngInject*/
	function searchServiceService() {
	    var params = {};
	    var article = {};
	    var recipe = {};
	    var initiative = {};
	    var key;
	    var subcategory;
	
	    this.getBaseURL = function () {
	        return baseURL;
	    };
	
	    this.setSearchParams = function (search) {
	        params = search;
	    };
	
	    this.getSearchParams = function () {
	        return params;
	    };
	
	    this.setArticle = function (data) {
	        article = data;
	    };
	
	    this.getArticle = function () {
	        return article;
	    };
	
	    this.setRecipe = function (data) {
	        recipe = data;
	    };
	
	    this.getRecipe = function () {
	        return recipe;
	    };
	
	    this.setInitiative = function (data) {
	        initiative = data;
	    };
	
	    this.getInitiative = function () {
	        return initiative;
	    };
	
	    this.setKey = function (data) {
	        key = data;
	    };
	
	    this.getKey = function () {
	        return key;
	    };
	
	    this.setSubCategory = function (data) {
	        subcategory = data;
	    };
	
	    this.getSubCategory = function () {
	        return subcategory;
	    };
	}
	
	exports.default = angular.module('connectwellTemplateApp.searchService', []).service('searchService', searchServiceService).name;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(78);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(80)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(79)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}@font-face{font-family:times_new_romanregular;src:url(\"/assets/fonts/times/times_new_roman-webfont.woff2\") format(\"woff2\"),url(\"/assets/fonts/times/times_new_roman-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:blackjackregular;src:url(\"/assets/fonts/black_jack/black_jack-webfont.woff2\") format(\"woff2\"),url(\"/assets/fonts/black_jack/black_jack-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Arial Regular;font-style:normal;font-weight:400;src:local(\"Arial Regular\"),url(\"/assets/fonts/arial/ARIAL.woff\") format(\"woff\")}@font-face{font-family:Arial Narrow;font-style:normal;font-weight:400;src:local(\"Arial Narrow\"),url(\"/assets/fonts/arial/ARIALN.woff\") format(\"woff\")}@font-face{font-family:Arial Italic;font-style:normal;font-weight:400;src:local(\"Arial Italic\"),url(\"/assets/fonts/arial/ARIALI 1.woff\") format(\"woff\")}@font-face{font-family:Arial Italic;font-style:normal;font-weight:400;src:local(\"Arial Italic\"),url(\"/assets/fonts/arial/ARIALI.woff\") format(\"woff\")}@font-face{font-family:Arial Narrow Italic;font-style:normal;font-weight:400;src:local(\"Arial Narrow Italic\"),url(\"/assets/fonts/arial/ARIALNI.woff\") format(\"woff\")}@font-face{font-family:Arial Medium;font-style:normal;font-weight:400;src:local(\"Arial Medium\"),url(\"/assets/fonts/arial/ArialMdm.woff\") format(\"woff\")}@font-face{font-family:Arial Medium Italic;font-style:normal;font-weight:400;src:local(\"Arial Medium Italic\"),url(\"/assets/fonts/arial/ArialMdmItl.woff\") format(\"woff\")}@font-face{font-family:Arial Bold;font-style:normal;font-weight:400;src:local(\"Arial Bold\"),url(\"/assets/fonts/arial/ARIALBD 1.woff\") format(\"woff\")}@font-face{font-family:Arial Bold;font-style:normal;font-weight:400;src:local(\"Arial Bold\"),url(\"/assets/fonts/arial/ARIALBD.woff\") format(\"woff\")}@font-face{font-family:Arial Narrow Bold;font-style:normal;font-weight:400;src:local(\"Arial Narrow Bold\"),url(\"/assets/fonts/arial/ARIALNB.woff\") format(\"woff\")}@font-face{font-family:Arial Bold Italic;font-style:normal;font-weight:400;src:local(\"Arial Bold Italic\"),url(\"/assets/fonts/arial/ARIALBI 1.woff\") format(\"woff\")}@font-face{font-family:Arial Bold Italic;font-style:normal;font-weight:400;src:local(\"Arial Bold Italic\"),url(\"/assets/fonts/arial/ARIALBI.woff\") format(\"woff\")}@font-face{font-family:Arial Narrow Bold Italic;font-style:normal;font-weight:400;src:local(\"Arial Narrow Bold Italic\"),url(\"/assets/fonts/arial/ARIALNBI.woff\") format(\"woff\")}@font-face{font-family:Arial Black;font-style:normal;font-weight:400;src:local(\"Arial Black\"),url(\"/assets/fonts/arial/ARIBLK.woff\") format(\"woff\")}@font-face{font-family:Arial Black Italic;font-style:normal;font-weight:400;src:local(\"Arial Black Italic\"),url(\"/assets/fonts/arial/ARIALBLACKITALIC.woff\") format(\"woff\")}@font-face{font-family:Arial Light Regular;font-style:normal;font-weight:400;src:local(\"Arial Light Regular\"),url(\"/assets/fonts/arial/ARIALLGT.woff\") format(\"woff\")}@font-face{font-family:Arial CE Regular;font-style:normal;font-weight:400;src:local(\"Arial CE Regular\"),url(\"/assets/fonts/arial/ArialCE.woff\") format(\"woff\")}@font-face{font-family:Arial CE MT Black Regular;font-style:normal;font-weight:400;src:local(\"Arial CE MT Black Regular\"),url(\"/assets/fonts/arial/ArialCEMTBlack.woff\") format(\"woff\")}@font-face{font-family:Arial CE Bold;font-style:normal;font-weight:400;src:local(\"Arial CE Bold\"),url(\"/assets/fonts/arial/arialceb.woff\") format(\"woff\")}@font-face{font-family:Arial Light Italic;font-style:normal;font-weight:400;src:local(\"Arial Light Italic\"),url(\"/assets/fonts/arial/ARIALLGTITL.woff\") format(\"woff\")}@font-face{font-family:Arial CE Italic;font-style:normal;font-weight:400;src:local(\"Arial CE Italic\"),url(\"/assets/fonts/arial/ArialCEItalic.woff\") format(\"woff\")}@font-face{font-family:Arial CE Bold Italic;font-style:normal;font-weight:400;src:local(\"Arial CE Bold Italic\"),url(\"/assets/fonts/arial/ArialCEBoldItalic.woff\") format(\"woff\")}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media screen and (min-width:768px){.container{max-width:730px}}body{font-family:Source Sans Pro,sans-serif;padding-top:54px;color:#000}@media (min-width:992px){body{padding-top:0;padding-left:17rem}}h1,h2,h3,h4,h5,h6{font-family:Source Sans Pro,sans-serif;font-weight:600;color:#000}h1{font-size:6rem;line-height:5.5rem}h2{font-size:3.5rem}.subheading{font-weight:700;font-family:Source Sans Pro,sans-serif;font-size:1.7rem;margin-top:-30px}.list-social-icons a{color:#495057}.list-social-icons a:hover{color:#1c5494}.list-social-icons a .fa-lg{font-size:1.75rem}.list-icons{font-size:3rem}.list-icons .list-inline-item i:hover{color:#1c5494}.pad-10{padding:10px}.pad-top-10{padding-top:10px}.pad-bottom-10{padding-bottom:10px}#sideNav .navbar-nav .nav-item .nav-link{font-weight:600;margin-left:17px;padding:3px}#sideNav .navbar-nav .nav-item .nav-link:hover{color:#bada55}@media (min-width:992px){#sideNav{text-align:left;top:0;left:0;display:flex;flex-direction:column;width:17rem;height:100vh}#sideNav .navbar-brand{display:flex;margin-left:0;margin-top:40px;padding:.5rem}#sideNav .navbar-brand .img-profile{position:relative;top:25px;max-width:100%;max-height:100%;width:100%;height:auto;margin-bottom:5px}#sideNav .navbar-collapse{display:flex;align-items:flex-start;flex-grow:0;width:100%;margin-bottom:auto}#sideNav .navbar-collapse .navbar-nav{flex-direction:column;width:100%}#sideNav .navbar-collapse .navbar-nav .nav-item,#sideNav .navbar-collapse .navbar-nav .nav-item .nav-link{display:block}#sideNav .color_white{color:#fff}#sideNav .font_5{font-size:14px;text-align:center}#sideNav .txtNew{position:relative;top:5px}#sideNav .txtNew h5{margin:0;line-height:normal;letter-spacing:normal}a{font:normal normal 700 14px/1.4em arial black,arial-w01-black,arial-w02-black,arial-w10 black,sans-serif;color:#fff;display:inline;white-space:nowrap;overflow:hidden}a:hover{color:#bada55}}.cw-navigation{left:28px;position:absolute;top:161px;height:144px;width:196px;min-width:188px}.cw-navigation a{font:normal normal 700 14px/1.4em arial black,arial-w01-black,arial-w02-black,arial-w10 black,sans-serif;color:#fff;display:inline;white-space:nowrap;overflow:hidden}.cw-navigation a:hover{color:#bada55}.color_white{color:#fff}.font_5{font-size:14px;text-align:center}.txtNew h5{margin:0;line-height:normal;letter-spacing:normal}.nav-spacer{margin-top:20px}section.resume-section{border-bottom:1px solid #dee2e6;padding-top:5rem!important;padding-bottom:5rem!important}section.resume-section .resume-item .resume-date{min-width:none}@media (min-width:768px){section.resume-section{min-height:100vh}section.resume-section .resume-item .resume-date{min-width:18rem}}@media (min-width:992px){section.resume-section{padding-top:3rem!important;padding-bottom:3rem!important}}.bg-primary{background-color:#1c5494!important}.text-primary{color:#1c5494!important}a{color:#1c5494}a:active,a:focus,a:hover{color:#102f54}footer.footer{text-align:center;padding:30px 0;margin-top:70px;border-top:1px solid #e5e5e5}.main-check{position:absolute;left:-1000px;bottom:-1000px}.blue-text{color:#196da8!important}.dark-blue-text{color:#1c5494!important}.orange-text{color:#f79330!important}.red-text{color:#ed1c24!important}.white-text{color:#fff!important}.black-text{color:#000!important}.blue-background{background-color:#196da8!important}.dark-blue-background{background-color:#1c5494!important}.orange-background{background-color:#f79330!important}.red-background{background-color:#ed1c24!important}.white-background{background-color:#fff!important}.black-background{background-color:#000}.light-gray-background{background-color:#d3d3d3!important}.text-size-10{font-size:10px!important}.text-size-12{font-size:12px!important}.text-size-14{font-size:14px!important}.text-size-16{font-size:16px!important}.text-size-18{font-size:18px!important}.text-size-20{font-size:20px!important}.table-footer{font-size:10px!important}.article-table{border-spacing:0!important;border-color:#fff!important;font-family:Arial Bold}.article-table td,.article-table th{border-bottom:1px solid #1c5494}.banner{font-family:blackjackregular;font-size:40pt}.btn-sq-lg{width:120px!important;height:120px!important;color:#fff!important;background-color:#2b558f}.btn-sq-lg:hover{background-color:red}.btn-sq{width:100px!important;height:100px!important}.btn-sq,.btn-sq-sm{font-size:10px;color:#fff}.btn-sq-sm{width:50px!important;height:50px!important}.btn-sq-xs{width:25px!important;height:25px!important;padding:2px;color:#fff}.btn-green{background-color:#7ba740!important;color:#fff!important}.btn-orange{background-color:#f79330;color:#fff!important}.dropdown-menu li{padding-left:5%!important;padding-right:5%!important}.dropdown-menu li:hover{background-color:#1c5494}.dropdown-menu li:hover a{color:#fff}.dropdown-menu{width:50%!important}.dropdown-menu li a{white-space:normal!important}.searchIcons{width:100px;height:100px;margin-bottom:5px}.searchBlock{padding:5px;margin:0;width:auto!important;text-align:center}.init_title{text-align:center;margin-top:30px;cursor:pointer}.searchBlock:hover{font-weight:700;color:#1c5494}.btn-main{background-color:#1c5494;color:#fff}.main-icons,.section-icons{margin-bottom:5px}.cursor-icon,.nav-item{cursor:pointer}.typeahead-demo .custom-popup-wrapper{position:absolute;top:100%;left:0;z-index:1000;display:none;background-color:#f9f9f9}.typeahead-demo .custom-popup-wrapper>.message{padding:10px 20px;border-bottom:1px solid #ddd;color:#868686}.typeahead-demo .custom-popup-wrapper>.dropdown-menu{position:static;float:none;display:block;min-width:160px;background-color:transparent;border:none;border-radius:0;box-shadow:none}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:red;text-decoration:underline;outline:0}.dropdown-menu{width:91%!important}.no-nav-margin,.no-nav-margin-articles{margin-left:0!important}@media print{@page{margin:0}body{margin:1.6cm}}a.list-group-item{height:auto;min-height:240px}a.list-group-item.active small{color:#fff}.stars{margin:20px auto 1px}.results-section{margin-top:50px;min-height:800px;overflow:scroll}.results-section .list-group-item{position:relative;display:block;margin-top:20px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.results-section .list-group-item .list-container{background-color:#fff;border:none}.well{min-height:20px;padding:19px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.list-group,.well{margin-bottom:20px}.list-group{padding-left:0}.list-content{max-width:100%}.topnav{overflow:hidden;background-color:#e9ecef}.topnav a{float:left;display:block;color:#000;text-align:center;padding:14px 16px;text-decoration:none;font-size:17px}.topnav a:hover{background-color:#ddd;color:#000}.topnav a.active{background-color:#1c5494;color:#fff}.topnav input[type=text]{float:right;padding:6px;border:none;margin-top:8px;margin-right:16px;font-size:17px}@media screen and (max-width:600px){.topnav a,.topnav input[type=text]{float:none;display:block;text-align:left;width:100%;margin:0;padding:14px}.topnav input[type=text]{border:1px solid #ccc}}.table-cw th{color:red}.articlesMargin{margin-left:-150px!important}.article-styles h1{font-family:Arial Bold;font-size:25pt;color:#1c5494;line-height:normal;font-weight:400;font-style:normal}.article-styles h2{font-size:16pt;color:#000}.article-styles h2,.article-styles h3{font-family:Arial Bold;font-weight:700;line-height:normal}.article-styles h3{font-size:14pt;color:#1c5494}.article-styles h4{font-family:Arial Bold;font-size:16pt;color:#1c5494;font-weight:400;font-style:normal;line-height:normal;padding-top:.75rem;padding-bottom:.75rem}.article-styles li,.article-styles p{font-family:Arial Regular;font-size:12pt;color:#000}.article-styles li{font-weight:400;font-style:normal}.article-styles ul.dashed{list-style-type:none}.article-styles ul.dashed>li{text-indent:-10px}.article-styles ul.dashed>li:before{content:\"-    \";text-indent:-10px}.article-styles .m-popup-image{padding-bottom:20px}.medical-box{border:1px solid #003262;margin-top:10px;margin-bottom:10px;padding:15px}.berkeley-footer{font-family:Arial Regular;font-size:12pt;font-style:normal;font-weight:400}.max-w-800{max-width:800px!important}.max-w-1000{max-width:1000px!important}.initiative-content{padding-top:20px}.initiative-title{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:25pt;color:#1c5494;line-height:normal;font-weight:700;font-style:normal}.initiative-content h1,.initiative-styles h1{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:20pt;color:#1c5494;line-height:normal;font-weight:700;font-style:normal}.initiative-content h2{font-size:16pt}.initiative-content h2,.initiative-content h3{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;color:#196da8;font-weight:700;line-height:normal}.initiative-content h3{font-size:12pt}.initiative-content h4{color:#f79330;font-weight:700;line-height:normal}.initiative-content h4,.initiative-content p{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:12pt}.initiative-content p{color:#000}.indent{padding-inline-start:17px!important}.initiative-content li{font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:12pt;color:#000;font-weight:400;font-style:normal}.initiative-content ul.sub-bullet{list-style-type:none}.initiative-content ul.sub-bullet>li{text-indent:-10px;padding-left:10px}.initiative-content ul.sub-bullet>li:before{color:orange;content:\"\\2022       \";text-indent:-10px}.initiative-content .box-red{background-color:#ed1c24;padding:15px;margin-top:10px}.initiative-content .box-red h2,.initiative-content .box-red ol>li,.initiative-content .box-red p,.initiative-content .box-red ul>li{color:#fff}.initiative-content .box-blue{background-color:#196da8;padding:15px;margin-top:10px}.initiative-content .box-darkblue{background-color:#1c5494;padding:15px;margin-top:10px}.initiative-content .box-orange{background-color:#f79330;padding:15px;margin-top:10px}.initiative-content .box-blue h2,.initiative-content .box-blue ol>li,.initiative-content .box-blue p,.initiative-content .box-blue ul>li,.initiative-content .box-darkblue h2,.initiative-content .box-darkblue ol>li,.initiative-content .box-darkblue p,.initiative-content .box-darkblue ul>li,.initiative-content .box-orange p{color:#fff}.initiative-content .box-orange h1,.initiative-content .box-orange h2{color:#fff!important}.initiative-content .box-orange ol>li,.initiative-content .box-orange ul>li{color:#fff}.footer-tagline{margin-top:20px;padding:5px}.footer-tagline .caption{color:#196da8;font-size:20px!important}.medical-box{border:1pt solid #1c5494;padding:10px;margin-top:20px}.ordered-list ol{list-style:none;counter-reset:li}.ordered-list li:before{content:counter(li);color:#f79330;font-weight:700;display:inline-block;width:1em;margin-left:-1em}.ordered-list li{counter-increment:li}.blue-text{color:#196da8}.orange-text{color:#f79330}.list-style-none{list-style-type:none!important}.list-underlined li{border-bottom:1px solid #000;margin-bottom:15px}.initiative-text{color:#e6843c!important;font-weight:700}.margin-auto{margin:auto!important}.recipe-color p{font-family:Arial Regular;font-size:12pt;font-style:normal}.ingredients p,.recipe-color,.recipe-color p{color:#00a598!important}.ingredients p{font-family:Arial Regular;font-size:12pt;font-style:normal}.normal-teal{color:#00a598!important}.recipe-styles h2,.title14{font-weight:700}.recipe-styles h1{font-size:25pt;font-weight:400;font-style:normal}.recipe-styles h1,.recipe-styles h2{font-family:Arial Bold;color:#859438;line-height:normal}.recipe-styles h2{font-size:14pt;margin:0!important;padding:0!important}.recipe-styles h3,.recipe-styles h4{font-family:Times New Roman,Times,serif;font-size:14pt;color:#000;font-weight:700;line-height:normal}.recipe-styles p{font-family:Arial Regular;font-size:12pt;color:#000}.prep-numbers{font-size:18pt;color:#00a598!important}.prep-numbers,.servings{font-family:Arial Bold;font-weight:700}.servings{font-size:11pt;color:#000}.title14{font-family:Arial Bold;font-size:14pt;color:#859438;line-height:normal}.no-nav-margin{margin-left:-150px!important}.no-nav-margin-recipes{margin-left:0!important}margin-auto{margin:auto!important}.shutterstockAttribution{text-align:right;padding-bottom:20px;color:gray;text-transform:uppercase;font-size:10pt}caption{padding-top:.75rem;padding-bottom:.75rem;caption-side:top!important;font-family:Arial Bold;font-size:14pt;color:#1c5494;font-weight:700;line-height:normal}caption,td{text-align:left}td{padding:12px;border-top:1px solid #ccc;vertical-align:top}table{width:100%}.subtitle-description,.video-description,.video-updateDate{padding:10px 0}", ""]);
	
	// exports


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.759ef847c320b02713d4.js